import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type AcceptInvitationDto = {
  password: Scalars['String']['input'];
  token: Scalars['String']['input'];
};

export type AdminBusinessType = {
  __typename?: 'AdminBusinessType';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
};

export type AdminOptionsDto = {
  archiveUser: Scalars['String']['input'];
  stripePriceId: Scalars['String']['input'];
};

export type AdminOptionsType = {
  __typename?: 'AdminOptionsType';
  archiveUser: Scalars['String']['output'];
  id: Scalars['String']['output'];
  stripePriceId: Scalars['String']['output'];
};

export type AdminPartnerType = {
  __typename?: 'AdminPartnerType';
  hasServiceCallAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type AdminUpdateUserDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type AdminUpdateVehicleDto = {
  isArchived: Scalars['Boolean']['input'];
  token: Scalars['String']['input'];
};

export type AdminUserType = {
  __typename?: 'AdminUserType';
  business?: Maybe<AdminBusinessType>;
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isBusinessAccountOwner: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isPartnerAccountOwner: Scalars['Boolean']['output'];
  level?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partner?: Maybe<AdminPartnerType>;
  stripeCustomerId?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type AdminVehicleList = {
  __typename?: 'AdminVehicleList';
  list: Array<AdminVehicleType>;
  totalCount: Scalars['Int']['output'];
};

export type AdminVehicleSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type AdminVehicleType = {
  __typename?: 'AdminVehicleType';
  VIN?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  business?: Maybe<AdminBusinessType>;
  id: Scalars['String']['output'];
  isArchived: Scalars['Boolean']['output'];
  model?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Float']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registerNumber?: Maybe<Scalars['String']['output']>;
  token?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  user?: Maybe<AdminUserType>;
};

export type AdminVehicleWhere = {
  VIN?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  registerNumber?: InputMaybe<Scalars['String']['input']>;
};

export type AuthResponse = {
  __typename?: 'AuthResponse';
  token: Scalars['String']['output'];
  user: UserType;
};

export type AuthStatusResponse = {
  __typename?: 'AuthStatusResponse';
  status: Scalars['String']['output'];
};

export type BusinessType = {
  __typename?: 'BusinessType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
};

export type ChangeUserInformationDto = {
  email: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type CompleteReminderDto = {
  mileage?: InputMaybe<Scalars['Int']['input']>;
  reminderId: Scalars['String']['input'];
  runningHours?: InputMaybe<Scalars['Int']['input']>;
  serviceEvents: Array<UpdateServiceEventDto>;
  vehicleId: Scalars['String']['input'];
};

export type CompleteReminderResponse = {
  __typename?: 'CompleteReminderResponse';
  count: Scalars['Int']['output'];
  ids: Array<Scalars['String']['output']>;
};

export type ConfirmDto = {
  confirmToken: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type CreateFaultDto = {
  description: Scalars['String']['input'];
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
};

export type CreateGroupDto = {
  name: Scalars['String']['input'];
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
};

export type CreateReminderDto = {
  date: Scalars['DateTime']['input'];
  faultId?: InputMaybe<Scalars['String']['input']>;
  isNotificationable?: InputMaybe<Scalars['Boolean']['input']>;
  notificationDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type CreateServiceEventDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  runningHours?: InputMaybe<Scalars['Int']['input']>;
  serviceDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type CreateVehicleDto = {
  VIN?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  commissioning?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  registerNumber?: InputMaybe<Scalars['String']['input']>;
  runningHours?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  warranty?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FaultList = {
  __typename?: 'FaultList';
  list: Array<FaultType>;
  totalCount: Scalars['Int']['output'];
};

export type FaultSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type FaultType = {
  __typename?: 'FaultType';
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDone: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  user: UserType;
  vehicle: VehicleType;
};

export type FaultWhere = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FeedbackStatusType = {
  __typename?: 'FeedbackStatusType';
  status: Scalars['String']['output'];
};

export type ForgotPasswordDto = {
  email: Scalars['String']['input'];
};

export type ForgotPasswordResponse = {
  __typename?: 'ForgotPasswordResponse';
  status: Scalars['String']['output'];
};

export type GroupList = {
  __typename?: 'GroupList';
  list: Array<GroupType>;
  totalCount: Scalars['Int']['output'];
};

export type GroupType = {
  __typename?: 'GroupType';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isDefault: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  notificationEmail?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userCount: Scalars['Int']['output'];
  userIds: Array<Scalars['String']['output']>;
  vehicleCount: Scalars['Int']['output'];
  vehicleIds: Array<Scalars['String']['output']>;
};

export type InviteBusinessUserDto = {
  email: Scalars['String']['input'];
  isEmployee: Scalars['Boolean']['input'];
  level?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type InvitePartnerCustomerDto = {
  email: Scalars['String']['input'];
};

export type InviteUserDto = {
  email: Scalars['String']['input'];
  level?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type LoginDto = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  /** [Admin] Approve service call application */
  aApproveServiceCallApplication: ServiceCallApplicationType;
  /** [Admin] Delete user */
  aDeleteUser: AdminUserType;
  /** [Admin] Reactivate inactive application access (moves to approved) */
  aReactivateServiceCallApplication: ServiceCallApplicationType;
  /** [Admin] Reject service call application */
  aRejectServiceCallApplication: ServiceCallApplicationType;
  /** [Admin] Revoke approved application access (moves to inactive) */
  aRevokeServiceCallApplication: ServiceCallApplicationType;
  /** [Admin] Set partner service call access */
  aSetPartnerServiceCallAccess: AdminPartnerType;
  /** [Admin] Update user */
  aUpdateUser: AdminUserType;
  /** [Admin] Update vehicle */
  aUpdateVehicle: AdminVehicleType;
  /** Complete user invitation */
  acceptInvitationToken: Scalars['Boolean']['output'];
  /** Peru avoin asiakaskutsu (master/admin) */
  cancelPartnerCustomerInvite: PartnerCustomerType;
  /** Update user information */
  changeUserInformation: UserType;
  /** Complete reminder */
  completeReminder: CompleteReminderResponse;
  /** Confirm user email */
  confirm: AuthStatusResponse;
  /** Create a new fault */
  createFault: FaultType;
  /** Luo uusi ryhmä */
  createGroup: GroupType;
  /** Luo ajoneuvo aktiivisen asiakasyrityksen puolesta */
  createPartnerCustomerVehicle: VehicleType;
  createReminder: ReminderType;
  /** Create service event */
  createServiceEvent: ServiceEventType;
  /** Create a transfer token for the vehicle */
  createTransferToken: Scalars['String']['output'];
  /** Create a vehicle */
  createVehicle: VehicleType;
  /** Create a voucher */
  createVoucher: VoucherType;
  /** Delete the fault */
  deleteFault: FaultType;
  /** Poista ryhmä */
  deleteGroup: GroupType;
  deleteReminder: ReminderType;
  /** Delete service event */
  deleteServiceEvent: ServiceEventType;
  /** Delete a service event attachment */
  deleteServiceEventAttachment: Scalars['Boolean']['output'];
  /** Delete user */
  deleteUser: UserType;
  /** Delete a vehicle */
  deleteVehicle: VehicleType;
  /** Delete a vehicle attachment */
  deleteVehicleAttachment: Scalars['Boolean']['output'];
  /** Päätä aktiivinen asiakkuus (vain master) */
  endPartnerCustomer: PartnerCustomerType;
  /** Päätä aktiivinen asiakkuus business-puolelta (vain master) */
  endPartnerCustomerByBusiness: PartnerCustomerType;
  /** Send forgot password link email to user */
  forgotPasswordConsumer: ForgotPasswordResponse;
  /** Send forgot password link email to user */
  forgotPasswordEmployee: ForgotPasswordResponse;
  /** Send forgot password link email to user */
  forgotPasswordPartner: ForgotPasswordResponse;
  /** Invite a user to the business */
  inviteBusinessUser: UserType;
  /** Kutsu asiakasyritys sähköpostilla (master/admin) */
  invitePartnerCustomer: PartnerCustomerType;
  /** Invite partner user */
  invitePartnerUser: UserType;
  /** Login a consumer user */
  loginClient: AuthResponse;
  /** Login a business user */
  loginEmployee: AuthResponse;
  /** Login a partner user */
  loginPartner: AuthResponse;
  /** Mark the fault as read */
  markAsRead: Scalars['Boolean']['output'];
  /** Mark the fault as unread */
  markAsUnread: Scalars['Boolean']['output'];
  /** Merkitse huoltokutsudashboardin vikailmoitus luetuksi (partner-scope) */
  markPartnerDashboardFaultRead: Scalars['Boolean']['output'];
  /** Merkitse huoltokutsudashboardin vikailmoitus lukemattomaksi (partner-scope) */
  markPartnerDashboardFaultUnread: Scalars['Boolean']['output'];
  /** Register a new business user account */
  registerBusinessUser: AuthResponse;
  /** Register a new consumer user account */
  registerConsumerUser: AuthResponse;
  /** Register a new partner user account */
  registerPartnerUser: AuthResponse;
  /** Account deletion request */
  requestAccountDelete: Scalars['Boolean']['output'];
  /** Resend confirmation email */
  resendConfirmation: AuthStatusResponse;
  /** Reset password with token */
  resetPassword: ResetPasswordResponse;
  /** Hyväksy tai hylkää saapunut partner-kutsu (vain master) */
  respondToPartnerInvite: PartnerCustomerType;
  /** Send feedback to the team */
  sendFeedback: FeedbackStatusType;
  /** Lähetä huoltokutsu asiakkaan ajoneuvolle ja luo muistutus (editor+) */
  sendPartnerServiceCall: Scalars['Boolean']['output'];
  /** Aseta ryhmän käyttäjäjäsenet */
  setGroupUsers: GroupType;
  /** Aseta ryhmän ajoneuvojäsenet */
  setGroupVehicles: GroupType;
  /** Lähetä huoltokutsuliittymän aktivointihakemus (master/admin) */
  submitServiceCallApplication: ServiceCallApplicationType;
  /** Transfer the vehicle to the user */
  transferVehicle: TransferVehicleType;
  /** [Admin] Transfer vehicle to business account */
  transferVehicleToBusiness: AdminVehicleType;
  /** [Admin] Transfer vehicle to user account */
  transferVehicleToConsumer: AdminVehicleType;
  /** Update admin options */
  updateAdminOptions: AdminOptionsType;
  /** Update the business details of the current user */
  updateBusiness: BusinessType;
  /** Update the fault details */
  updateFault: FaultType;
  /** Mark the fault as done */
  updateFaultAsDone: FaultType;
  /** Päivitä ryhmän nimi ja/tai ilmoitusosoite */
  updateGroup: GroupType;
  /** Update partner details by user */
  updatePartner: PartnerType;
  /** Päivitä aktiivisen huoltokumppanuuden ryhmäoikeudet (vain master) */
  updatePartnerCustomerGroups: PartnerCustomerType;
  updateReminder: ReminderType;
  /** Update service event */
  updateServiceEvent: ServiceEventType;
  /** Update the level of a user within the same organization */
  updateUserLevel: UserType;
  /** Update a vehicle */
  updateVehicle: VehicleType;
  /** Update vehicle attachment name */
  updateVehicleAttachmentName: VehicleAttachmentType;
  /** Update a voucher */
  updateVoucher: VoucherType;
  /** Use a voucher */
  useVoucher: VoucherLogType;
  /** Verify if the invitation token is valid */
  verifyAcceptInvitationToken: Scalars['Boolean']['output'];
};


export type MutationAApproveServiceCallApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationADeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationAReactivateServiceCallApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationARejectServiceCallApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationARevokeServiceCallApplicationArgs = {
  id: Scalars['String']['input'];
};


export type MutationASetPartnerServiceCallAccessArgs = {
  hasAccess: Scalars['Boolean']['input'];
  partnerId: Scalars['String']['input'];
};


export type MutationAUpdateUserArgs = {
  body: AdminUpdateUserDto;
  id: Scalars['String']['input'];
};


export type MutationAUpdateVehicleArgs = {
  body: AdminUpdateVehicleDto;
  id: Scalars['String']['input'];
};


export type MutationAcceptInvitationTokenArgs = {
  body: AcceptInvitationDto;
};


export type MutationCancelPartnerCustomerInviteArgs = {
  id: Scalars['String']['input'];
};


export type MutationChangeUserInformationArgs = {
  body: ChangeUserInformationDto;
};


export type MutationCompleteReminderArgs = {
  body: CompleteReminderDto;
};


export type MutationConfirmArgs = {
  body: ConfirmDto;
};


export type MutationCreateFaultArgs = {
  body: CreateFaultDto;
};


export type MutationCreateGroupArgs = {
  body: CreateGroupDto;
};


export type MutationCreatePartnerCustomerVehicleArgs = {
  body: CreateVehicleDto;
  businessId: Scalars['String']['input'];
};


export type MutationCreateReminderArgs = {
  body: CreateReminderDto;
};


export type MutationCreateServiceEventArgs = {
  body: CreateServiceEventDto;
};


export type MutationCreateTransferTokenArgs = {
  vehicleId: Scalars['String']['input'];
};


export type MutationCreateVehicleArgs = {
  body: CreateVehicleDto;
};


export type MutationCreateVoucherArgs = {
  body: VoucherDto;
};


export type MutationDeleteFaultArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteGroupArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteReminderArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteServiceEventArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteServiceEventAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVehicleArgs = {
  id: Scalars['String']['input'];
};


export type MutationDeleteVehicleAttachmentArgs = {
  id: Scalars['String']['input'];
};


export type MutationEndPartnerCustomerArgs = {
  id: Scalars['String']['input'];
};


export type MutationEndPartnerCustomerByBusinessArgs = {
  id: Scalars['String']['input'];
};


export type MutationForgotPasswordConsumerArgs = {
  body: ForgotPasswordDto;
};


export type MutationForgotPasswordEmployeeArgs = {
  body: ForgotPasswordDto;
};


export type MutationForgotPasswordPartnerArgs = {
  body: ForgotPasswordDto;
};


export type MutationInviteBusinessUserArgs = {
  body: InviteBusinessUserDto;
};


export type MutationInvitePartnerCustomerArgs = {
  body: InvitePartnerCustomerDto;
};


export type MutationInvitePartnerUserArgs = {
  body: InviteUserDto;
};


export type MutationLoginClientArgs = {
  body: LoginDto;
};


export type MutationLoginEmployeeArgs = {
  body: LoginDto;
};


export type MutationLoginPartnerArgs = {
  body: LoginDto;
};


export type MutationMarkAsReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkAsUnreadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkPartnerDashboardFaultReadArgs = {
  id: Scalars['String']['input'];
};


export type MutationMarkPartnerDashboardFaultUnreadArgs = {
  id: Scalars['String']['input'];
};


export type MutationRegisterBusinessUserArgs = {
  body: RegisterBusinessUserDto;
};


export type MutationRegisterConsumerUserArgs = {
  body: RegisterConsumerUserDto;
};


export type MutationRegisterPartnerUserArgs = {
  body: RegisterPartnerUserDto;
};


export type MutationResetPasswordArgs = {
  body: ResetPasswordDto;
};


export type MutationRespondToPartnerInviteArgs = {
  accept: Scalars['Boolean']['input'];
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  id: Scalars['String']['input'];
};


export type MutationSendFeedbackArgs = {
  message: Scalars['String']['input'];
};


export type MutationSendPartnerServiceCallArgs = {
  body: SendPartnerServiceCallDto;
};


export type MutationSetGroupUsersArgs = {
  body: SetGroupUsersDto;
  id: Scalars['String']['input'];
};


export type MutationSetGroupVehiclesArgs = {
  body: SetGroupVehiclesDto;
  id: Scalars['String']['input'];
};


export type MutationSubmitServiceCallApplicationArgs = {
  body: SubmitServiceCallApplicationDto;
};


export type MutationTransferVehicleArgs = {
  token: Scalars['String']['input'];
};


export type MutationTransferVehicleToBusinessArgs = {
  businessId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};


export type MutationTransferVehicleToConsumerArgs = {
  id: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationUpdateAdminOptionsArgs = {
  body: AdminOptionsDto;
};


export type MutationUpdateBusinessArgs = {
  body: UpdateBusinessDto;
};


export type MutationUpdateFaultArgs = {
  body: UpdateFaultDto;
  id: Scalars['String']['input'];
};


export type MutationUpdateFaultAsDoneArgs = {
  id: Scalars['String']['input'];
};


export type MutationUpdateGroupArgs = {
  body: UpdateGroupDto;
  id: Scalars['String']['input'];
};


export type MutationUpdatePartnerArgs = {
  body: UpdatePartnerDto;
};


export type MutationUpdatePartnerCustomerGroupsArgs = {
  groupIds: Array<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


export type MutationUpdateReminderArgs = {
  body: UpdateReminderDto;
  id: Scalars['String']['input'];
};


export type MutationUpdateServiceEventArgs = {
  body: UpdateServiceEventDto;
  id: Scalars['String']['input'];
};


export type MutationUpdateUserLevelArgs = {
  body: UpdateUserLevelDto;
};


export type MutationUpdateVehicleArgs = {
  body: UpdateVehicleDto;
  id: Scalars['String']['input'];
};


export type MutationUpdateVehicleAttachmentNameArgs = {
  id: Scalars['String']['input'];
  name: Scalars['String']['input'];
};


export type MutationUpdateVoucherArgs = {
  body: VoucherDto;
  id: Scalars['String']['input'];
};


export type MutationUseVoucherArgs = {
  vehicleId: Scalars['String']['input'];
  voucher: Scalars['String']['input'];
};


export type MutationVerifyAcceptInvitationTokenArgs = {
  body: VerifyAcceptInvitationDto;
};

export type PartnerCustomerInviteType = {
  __typename?: 'PartnerCustomerInviteType';
  businessId: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type PartnerCustomerList = {
  __typename?: 'PartnerCustomerList';
  list: Array<PartnerCustomerListItemType>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerCustomerListItemType = {
  __typename?: 'PartnerCustomerListItemType';
  businessId: Scalars['String']['output'];
  businessName: Scalars['String']['output'];
  id: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  vehicleCount: Scalars['Int']['output'];
};

export type PartnerCustomerSort = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  startedAt?: InputMaybe<Scalars['String']['input']>;
  vehicleCount?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerCustomerType = {
  __typename?: 'PartnerCustomerType';
  allowedGroupIds: Array<Scalars['String']['output']>;
  businessId: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  invitedByUserId?: Maybe<Scalars['String']['output']>;
  partner: PartnerType;
  partnerId: Scalars['String']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type PartnerCustomerVehicleList = {
  __typename?: 'PartnerCustomerVehicleList';
  businessName: Scalars['String']['output'];
  list: Array<VehicleType>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerCustomerVehicleSort = {
  VIN?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  licenseExpireDate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  registerNumber?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerDashboardFaultList = {
  __typename?: 'PartnerDashboardFaultList';
  list: Array<PartnerDashboardFaultType>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerDashboardFaultSort = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  isDone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
  vehicleName?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerDashboardFaultType = {
  __typename?: 'PartnerDashboardFaultType';
  businessName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  description: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isDone: Scalars['Boolean']['output'];
  isRead: Scalars['Boolean']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  userName?: Maybe<Scalars['String']['output']>;
  vehicle: VehicleType;
  vehicleId: Scalars['String']['output'];
};

export type PartnerDashboardReminderList = {
  __typename?: 'PartnerDashboardReminderList';
  list: Array<PartnerDashboardReminderType>;
  totalCount: Scalars['Int']['output'];
};

export type PartnerDashboardReminderSort = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  vehicleName?: InputMaybe<Scalars['String']['input']>;
};

export type PartnerDashboardReminderType = {
  __typename?: 'PartnerDashboardReminderType';
  businessName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  vehicle: VehicleType;
  vehicleId: Scalars['String']['output'];
};

export type PartnerDashboardVehicleType = {
  __typename?: 'PartnerDashboardVehicleType';
  VIN?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  registerNumber?: Maybe<Scalars['String']['output']>;
};

export type PartnerType = {
  __typename?: 'PartnerType';
  hasServiceCallAccess: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  photo?: Maybe<Scalars['String']['output']>;
};

export type Query = {
  __typename?: 'Query';
  /** [Admin] Get business */
  aBusiness: AdminBusinessType;
  /** [Admin] Get service call application */
  aServiceCallApplication: ServiceCallApplicationType;
  /** [Admin] Get service call applications */
  aServiceCallApplications: ServiceCallApplicationList;
  /** [Admin] Get user */
  aUser: AdminUserType;
  /** [Admin] Get users */
  aUsers: UserList;
  /** [Admin] Get a vehicle */
  aVehicle: AdminVehicleType;
  /** [Admin] Get vehicles */
  aVehicles: AdminVehicleList;
  /** Get admin options */
  adminOptions: AdminOptionsType;
  /** Get the business details of the current user */
  business: BusinessType;
  /** Voiko partner lähettää huoltokutsun tälle ajoneuvolle (aktiivinen asiakkuus) */
  canSendPartnerServiceCall: Scalars['Boolean']['output'];
  /** Create a new checkout session */
  createCheckoutSession: StripeCheckoutType;
  /** [Admin] Export users as CSV */
  exportCSV: Scalars['String']['output'];
  /** Get the fault details */
  fault: FaultType;
  /** Get the list of faults */
  faults: FaultList;
  /** Hae yksittäinen ryhmä */
  group: GroupType;
  /** Listaa yrityksen ajoneuvot ryhmäjäsenyyden hallintaan */
  groupAssignableVehicles: VehicleList;
  /** Listaa yrityksen ryhmät */
  groups: GroupList;
  /** Aktiiviset huoltokumppanuudet (vain business-master) */
  myActivePartnerships: Array<PartnerCustomerType>;
  /** Listaa nykyisen käyttäjän ryhmät ajoneuvolistan suodatukseen */
  myGroups: GroupList;
  /** Saapuvat avoimet partner-kutsut (vain business-master) */
  myIncomingPartnerInvites: Array<PartnerCustomerType>;
  /** Partnerin huoltokutsuliittymän tila (none/pending/approved/inactive) */
  myServiceCallAccessState: Scalars['String']['output'];
  /** Get partner details by user */
  partner: PartnerType;
  /** Avoimet asiakaskutsut (pending) */
  partnerCustomerInvites: Array<PartnerCustomerInviteType>;
  /** Aktiivisen asiakasyrityksen ajoneuvot perustietoineen (huoltokutsuliittymä) */
  partnerCustomerVehicles: PartnerCustomerVehicleList;
  /** Aktiiviset asiakasyritykset (nimi, aloituspäivä, ajoneuvomäärä) */
  partnerCustomers: PartnerCustomerList;
  /** Yksittäinen vikailmoitus aktiivisen asiakkaan ajoneuvosta (huoltokutsuliittymä) */
  partnerDashboardFault: PartnerDashboardFaultType;
  /** Aktiivisten asiakasyritysten vikailmoitukset (huoltokutsuliittymä) */
  partnerDashboardFaults: PartnerDashboardFaultList;
  /** Aktiivisten asiakasyritysten muistutukset eräpäivän mukaan (huoltokutsuliittymä) */
  partnerDashboardReminders: PartnerDashboardReminderList;
  /** Aktiivisten asiakasyritysten ajoneuvot dashboard-suodattimelle */
  partnerDashboardVehicles: Array<PartnerDashboardVehicleType>;
  reminder: ReminderType;
  reminders: ReminderList;
  /** [Admin] Request admin login token */
  requestAdminToken: AuthStatusResponse;
  /** Search a vehicle by token */
  searchVehicle: VehicleType;
  /** Get service event */
  serviceEvent: ServiceEventType;
  /** Get all users */
  users: UserList;
  /** [Admin] Validate admin token */
  validateAdminToken: AuthStatusResponse;
  /** Validate reset password token */
  validateResetToken: ValidateResetTokenResponse;
  /** Validate the transfer token */
  validateTransferToken: ValidateTransferTokenType;
  /** Get a vehicle */
  vehicle: VehicleType;
  /** Get a list of vehicles */
  vehicles: VehicleList;
  /** Get a voucher */
  voucher: VoucherType;
  /** Get a list of vouchers */
  vouchers: VoucherList;
  /** Get user information */
  whoAmI: UserType;
};


export type QueryABusinessArgs = {
  id: Scalars['String']['input'];
};


export type QueryAServiceCallApplicationArgs = {
  id: Scalars['String']['input'];
};


export type QueryAServiceCallApplicationsArgs = {
  orderBy?: InputMaybe<Array<ServiceCallApplicationSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceCallApplicationWhere>;
};


export type QueryAUserArgs = {
  id: Scalars['String']['input'];
};


export type QueryAUsersArgs = {
  orderBy?: InputMaybe<Array<UserSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<UserWhere>;
};


export type QueryAVehicleArgs = {
  id: Scalars['String']['input'];
};


export type QueryAVehiclesArgs = {
  orderBy?: InputMaybe<Array<AdminVehicleSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<AdminVehicleWhere>;
};


export type QueryCanSendPartnerServiceCallArgs = {
  vehicleId: Scalars['String']['input'];
};


export type QueryCreateCheckoutSessionArgs = {
  vehicleId: Scalars['String']['input'];
};


export type QueryFaultArgs = {
  id: Scalars['String']['input'];
};


export type QueryFaultsArgs = {
  orderBy?: InputMaybe<Array<FaultSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<FaultWhere>;
};


export type QueryGroupArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerCustomerVehiclesArgs = {
  businessId: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<PartnerCustomerVehicleSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerCustomersArgs = {
  orderBy?: InputMaybe<Array<PartnerCustomerSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryPartnerDashboardFaultArgs = {
  id: Scalars['String']['input'];
};


export type QueryPartnerDashboardFaultsArgs = {
  orderBy?: InputMaybe<Array<PartnerDashboardFaultSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceCallDashboardWhere>;
};


export type QueryPartnerDashboardRemindersArgs = {
  orderBy?: InputMaybe<Array<PartnerDashboardReminderSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceCallDashboardWhere>;
};


export type QueryPartnerDashboardVehiclesArgs = {
  where?: InputMaybe<ServiceCallDashboardWhere>;
};


export type QueryReminderArgs = {
  id: Scalars['String']['input'];
};


export type QueryRemindersArgs = {
  orderBy?: InputMaybe<Array<ReminderSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReminderWhere>;
};


export type QuerySearchVehicleArgs = {
  token: Scalars['String']['input'];
};


export type QueryServiceEventArgs = {
  id: Scalars['String']['input'];
};


export type QueryValidateResetTokenArgs = {
  body: ValidateResetTokenDto;
};


export type QueryValidateTransferTokenArgs = {
  token: Scalars['String']['input'];
};


export type QueryVehicleArgs = {
  id: Scalars['String']['input'];
};


export type QueryVehiclesArgs = {
  orderBy?: InputMaybe<Array<VehicleSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VehicleWhere>;
};


export type QueryVoucherArgs = {
  id: Scalars['String']['input'];
};


export type QueryVouchersArgs = {
  orderBy?: InputMaybe<Array<VoucherSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<VoucherWhere>;
};

export type RegisterBusinessUserDto = {
  businessName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  isAccepted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RegisterConsumerUserDto = {
  email: Scalars['String']['input'];
  isAccepted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type RegisterPartnerUserDto = {
  email: Scalars['String']['input'];
  isAccepted: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  partnerName: Scalars['String']['input'];
  password: Scalars['String']['input'];
};

export type ReminderList = {
  __typename?: 'ReminderList';
  list: Array<ReminderType>;
  totalCount: Scalars['Int']['output'];
};

export type ReminderSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ReminderType = {
  __typename?: 'ReminderType';
  createdAt: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isNotificationable?: Maybe<Scalars['Boolean']['output']>;
  isPartnerLocked: Scalars['Boolean']['output'];
  notificationDaysBefore?: Maybe<Scalars['Float']['output']>;
  title: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vehicle: VehicleType;
  vehicleId: Scalars['String']['output'];
};

export type ReminderWhere = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ResetPasswordDto = {
  password: Scalars['String']['input'];
  resetPasswordToken: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ResetPasswordResponse = {
  __typename?: 'ResetPasswordResponse';
  status: Scalars['String']['output'];
};

export type SendPartnerServiceCallDto = {
  body: Scalars['String']['input'];
  date: Scalars['DateTime']['input'];
  title: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type ServiceCallApplicationList = {
  __typename?: 'ServiceCallApplicationList';
  list: Array<ServiceCallApplicationType>;
  totalCount: Scalars['Int']['output'];
};

export type ServiceCallApplicationSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  handledAt?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCallApplicationType = {
  __typename?: 'ServiceCallApplicationType';
  businessId: Scalars['String']['output'];
  city: Scalars['String']['output'];
  contactName: Scalars['String']['output'];
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  handledAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['String']['output'];
  industry: Scalars['String']['output'];
  officialName: Scalars['String']['output'];
  partnerId: Scalars['String']['output'];
  personnelCount?: Maybe<Scalars['Int']['output']>;
  phone: Scalars['String']['output'];
  postalCode: Scalars['String']['output'];
  status: Scalars['String']['output'];
  streetAddress: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ServiceCallApplicationWhere = {
  id?: InputMaybe<Scalars['String']['input']>;
  officialName?: InputMaybe<Scalars['String']['input']>;
  partnerId?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceCallDashboardDateRange = {
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ServiceCallDashboardWhere = {
  businessId?: InputMaybe<Scalars['String']['input']>;
  date?: InputMaybe<ServiceCallDashboardDateRange>;
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  isRead?: InputMaybe<Scalars['Boolean']['input']>;
  vehicleId?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceEventAttachmentType = {
  __typename?: 'ServiceEventAttachmentType';
  canDelete: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type ServiceEventSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  serviceDate?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type ServiceEventType = {
  __typename?: 'ServiceEventType';
  attachments: Array<ServiceEventAttachmentType>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  isLocked: Scalars['Boolean']['output'];
  isPartnerLocked: Scalars['Boolean']['output'];
  isTimeLocked: Scalars['Boolean']['output'];
  mileage?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
  partner?: Maybe<PartnerType>;
  partnerId?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  runningHours?: Maybe<Scalars['Int']['output']>;
  serviceDate: Scalars['DateTime']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  vehicle: VehicleType;
  vehicleId: Scalars['String']['output'];
};

export type ServiceEventWhere = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SetGroupUsersDto = {
  userIds: Array<Scalars['String']['input']>;
};

export type SetGroupVehiclesDto = {
  vehicleIds: Array<Scalars['String']['input']>;
};

export type StringListHasFilter = {
  has?: InputMaybe<Scalars['String']['input']>;
};

export type StripeCheckoutType = {
  __typename?: 'StripeCheckoutType';
  url: Scalars['String']['output'];
};

export type SubmitServiceCallApplicationDto = {
  businessId: Scalars['String']['input'];
  city: Scalars['String']['input'];
  contactName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  industry: Scalars['String']['input'];
  officialName: Scalars['String']['input'];
  personnelCount?: InputMaybe<Scalars['Int']['input']>;
  phone: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  streetAddress: Scalars['String']['input'];
};

export type TransferVehicleType = {
  __typename?: 'TransferVehicleType';
  vehicleId: Scalars['String']['output'];
};

export type UpdateBusinessDto = {
  name: Scalars['String']['input'];
};

export type UpdateFaultDto = {
  description: Scalars['String']['input'];
  isDone?: InputMaybe<Scalars['Boolean']['input']>;
  photoId?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateGroupDto = {
  name?: InputMaybe<Scalars['String']['input']>;
  notificationEmail?: InputMaybe<Scalars['String']['input']>;
};

export type UpdatePartnerDto = {
  name: Scalars['String']['input'];
};

export type UpdateReminderDto = {
  date: Scalars['DateTime']['input'];
  isNotificationable?: InputMaybe<Scalars['Boolean']['input']>;
  notificationDaysBefore?: InputMaybe<Scalars['Int']['input']>;
  title: Scalars['String']['input'];
};

export type UpdateServiceEventDto = {
  description?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  name: Scalars['String']['input'];
  runningHours?: InputMaybe<Scalars['Int']['input']>;
  serviceDate: Scalars['DateTime']['input'];
  type: Scalars['String']['input'];
};

export type UpdateUserLevelDto = {
  level: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export type UpdateVehicleDto = {
  VIN?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  commissioning?: InputMaybe<Scalars['DateTime']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  mileage?: InputMaybe<Scalars['Int']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  modelYear?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  photo?: InputMaybe<Scalars['String']['input']>;
  registerNumber?: InputMaybe<Scalars['String']['input']>;
  runningHours?: InputMaybe<Scalars['Int']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  warranty?: InputMaybe<Scalars['DateTime']['input']>;
};

export type UserList = {
  __typename?: 'UserList';
  list: Array<AdminUserType>;
  totalCount: Scalars['Int']['output'];
};

export type UserSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type UserType = {
  __typename?: 'UserType';
  business?: Maybe<BusinessType>;
  createdAt: Scalars['DateTime']['output'];
  email: Scalars['String']['output'];
  id: Scalars['String']['output'];
  isBusinessAccountOwner: Scalars['Boolean']['output'];
  isConfirmed: Scalars['Boolean']['output'];
  isEmployee: Scalars['Boolean']['output'];
  isPartnerAccountOwner: Scalars['Boolean']['output'];
  level?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  partner?: Maybe<PartnerType>;
  type: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type UserWhere = {
  businessName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  partnerName?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type ValidateResetTokenDto = {
  resetPasswordToken: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ValidateResetTokenResponse = {
  __typename?: 'ValidateResetTokenResponse';
  status: Scalars['Boolean']['output'];
};

export type ValidateTransferTokenType = {
  __typename?: 'ValidateTransferTokenType';
  isVehicleOwner: Scalars['Boolean']['output'];
};

export type VehicleAttachmentType = {
  __typename?: 'VehicleAttachmentType';
  canDelete: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type VehicleList = {
  __typename?: 'VehicleList';
  list: Array<VehicleType>;
  totalCount: Scalars['Int']['output'];
};

export type VehicleSort = {
  VIN?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  licenseExpireDate?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type VehicleType = {
  __typename?: 'VehicleType';
  VIN?: Maybe<Scalars['String']['output']>;
  attachments: Array<VehicleAttachmentType>;
  brand?: Maybe<Scalars['String']['output']>;
  businessId?: Maybe<Scalars['String']['output']>;
  commissioning?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  description?: Maybe<Scalars['String']['output']>;
  hasActiveLicense: Scalars['Boolean']['output'];
  id: Scalars['String']['output'];
  licenseExpireDate: Scalars['DateTime']['output'];
  licenseStatus: Scalars['String']['output'];
  mileage?: Maybe<Scalars['Int']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  modelYear?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  photo?: Maybe<Scalars['String']['output']>;
  registerNumber?: Maybe<Scalars['String']['output']>;
  reminders: Array<ReminderType>;
  runningHours?: Maybe<Scalars['Int']['output']>;
  serviceEvents: Array<ServiceEventType>;
  token: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  userId?: Maybe<Scalars['String']['output']>;
  warranty?: Maybe<Scalars['DateTime']['output']>;
};


export type VehicleTypeRemindersArgs = {
  orderBy?: InputMaybe<Array<ReminderSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReminderWhere>;
};


export type VehicleTypeServiceEventsArgs = {
  orderBy?: InputMaybe<Array<ServiceEventSort>>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceEventWhere>;
};

export type VehicleWhere = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
  groupIds?: InputMaybe<StringListHasFilter>;
  id?: InputMaybe<Scalars['String']['input']>;
  token?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type VerifyAcceptInvitationDto = {
  inviteToken: Scalars['String']['input'];
};

export type VoucherDto = {
  endDate: Scalars['DateTime']['input'];
  isActive: Scalars['Boolean']['input'];
  name: Scalars['String']['input'];
  useLimit: Scalars['Int']['input'];
};

export type VoucherList = {
  __typename?: 'VoucherList';
  list: Array<VoucherType>;
  totalCount: Scalars['Int']['output'];
};

export type VoucherLogType = {
  __typename?: 'VoucherLogType';
  id: Scalars['String']['output'];
};

export type VoucherSort = {
  createdAt?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['String']['input']>;
};

export type VoucherType = {
  __typename?: 'VoucherType';
  createdAt: Scalars['DateTime']['output'];
  endDate: Scalars['DateTime']['output'];
  id: Scalars['String']['output'];
  isActive: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
  useLimit: Scalars['Int']['output'];
  uses: Scalars['Int']['output'];
};

export type VoucherWhere = {
  createdAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CreateCheckoutSessionQueryVariables = Exact<{
  vehicleId: Scalars['String']['input'];
}>;


export type CreateCheckoutSessionQuery = { __typename?: 'Query', createCheckoutSession: { __typename?: 'StripeCheckoutType', url: string } };

export type FindVehicleQueryVariables = Exact<{
  token: Scalars['String']['input'];
}>;


export type FindVehicleQuery = { __typename?: 'Query', searchVehicle: { __typename?: 'VehicleType', id: string } };

export type ResendConfirmMutationVariables = Exact<{ [key: string]: never; }>;


export type ResendConfirmMutation = { __typename?: 'Mutation', resendConfirmation: { __typename?: 'AuthStatusResponse', status: string } };

export type SendFeedbackMutationVariables = Exact<{
  message: Scalars['String']['input'];
}>;


export type SendFeedbackMutation = { __typename?: 'Mutation', sendFeedback: { __typename?: 'FeedbackStatusType', status: string } };

export type StripeSceneQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type StripeSceneQuery = { __typename?: 'Query', vehicle: { __typename?: 'VehicleType', id: string, licenseExpireDate: any } };

export type UseVoucherMutationVariables = Exact<{
  vehicleId: Scalars['String']['input'];
  voucher: Scalars['String']['input'];
}>;


export type UseVoucherMutation = { __typename?: 'Mutation', useVoucher: { __typename?: 'VoucherLogType', id: string } };

export type WhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type WhoAmIQuery = { __typename?: 'Query', whoAmI: { __typename?: 'UserType', id: string, email: string, name: string, isConfirmed: boolean, level?: string | null, isPartnerAccountOwner: boolean, partner?: { __typename?: 'PartnerType', id: string, name: string, photo?: string | null, hasServiceCallAccess: boolean } | null } };

export type VerifyAcceptInvitationTokenMutationVariables = Exact<{
  body: VerifyAcceptInvitationDto;
}>;


export type VerifyAcceptInvitationTokenMutation = { __typename?: 'Mutation', verifyAcceptInvitationToken: boolean };

export type AcceptInvitationMutationVariables = Exact<{
  body: AcceptInvitationDto;
}>;


export type AcceptInvitationMutation = { __typename?: 'Mutation', acceptInvitationToken: boolean };

export type ConfirmMutationVariables = Exact<{
  body: ConfirmDto;
}>;


export type ConfirmMutation = { __typename?: 'Mutation', confirm: { __typename?: 'AuthStatusResponse', status: string } };

export type ForgotPasswordMutationVariables = Exact<{
  body: ForgotPasswordDto;
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPasswordPartner: { __typename?: 'ForgotPasswordResponse', status: string } };

export type LoginMutationVariables = Exact<{
  body: LoginDto;
}>;


export type LoginMutation = { __typename?: 'Mutation', loginPartner: { __typename?: 'AuthResponse', token: string, user: { __typename?: 'UserType', id: string, name: string } } };

export type RegisterPartnerMutationVariables = Exact<{
  body: RegisterPartnerUserDto;
}>;


export type RegisterPartnerMutation = { __typename?: 'Mutation', registerPartnerUser: { __typename?: 'AuthResponse', token: string } };

export type ResetPasswordMutationVariables = Exact<{
  body: ResetPasswordDto;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword: { __typename?: 'ResetPasswordResponse', status: string } };

export type ValidateResetTokenQueryVariables = Exact<{
  body: ValidateResetTokenDto;
}>;


export type ValidateResetTokenQuery = { __typename?: 'Query', validateResetToken: { __typename?: 'ValidateResetTokenResponse', status: boolean } };

export type CreateReminderMutationVariables = Exact<{
  body: CreateReminderDto;
}>;


export type CreateReminderMutation = { __typename?: 'Mutation', createReminder: { __typename?: 'ReminderType', id: string } };

export type UpdateReminderMutationVariables = Exact<{
  id: Scalars['String']['input'];
  body: UpdateReminderDto;
}>;


export type UpdateReminderMutation = { __typename?: 'Mutation', updateReminder: { __typename?: 'ReminderType', id: string } };

export type ReminderQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ReminderQuery = { __typename?: 'Query', reminder: { __typename?: 'ReminderType', title: string, date: any } };

export type RemindersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ReminderSort> | ReminderSort>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ReminderWhere>;
}>;


export type RemindersQuery = { __typename?: 'Query', reminders: { __typename?: 'ReminderList', totalCount: number, list: Array<{ __typename?: 'ReminderType', id: string, title: string, date: any, vehicleId: string, vehicle: { __typename?: 'VehicleType', id: string, name?: string | null, registerNumber?: string | null, VIN?: string | null, brand?: string | null, model?: string | null } }> } };

export type CreatePartnerCustomerVehicleMutationVariables = Exact<{
  businessId: Scalars['String']['input'];
  body: CreateVehicleDto;
}>;


export type CreatePartnerCustomerVehicleMutation = { __typename?: 'Mutation', createPartnerCustomerVehicle: { __typename?: 'VehicleType', id: string } };

export type PartnerCustomerVehiclesQueryVariables = Exact<{
  businessId: Scalars['String']['input'];
  orderBy?: InputMaybe<Array<PartnerCustomerVehicleSort> | PartnerCustomerVehicleSort>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartnerCustomerVehiclesQuery = { __typename?: 'Query', partnerCustomerVehicles: { __typename?: 'PartnerCustomerVehicleList', businessName: string, totalCount: number, list: Array<{ __typename?: 'VehicleType', id: string, name?: string | null, registerNumber?: string | null, model?: string | null, brand?: string | null, licenseExpireDate: any, licenseStatus: string, VIN?: string | null }> } };

export type PartnerCustomersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<PartnerCustomerSort> | PartnerCustomerSort>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PartnerCustomersQuery = { __typename?: 'Query', partnerCustomers: { __typename?: 'PartnerCustomerList', totalCount: number, list: Array<{ __typename?: 'PartnerCustomerListItemType', id: string, businessId: string, status: string, startedAt?: any | null, businessName: string, vehicleCount: number }> } };

export type PartnerCustomerInvitesQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerCustomerInvitesQuery = { __typename?: 'Query', partnerCustomerInvites: Array<{ __typename?: 'PartnerCustomerInviteType', id: string, businessId: string, createdAt: any, businessName: string, email: string }> };

export type InvitePartnerCustomerMutationVariables = Exact<{
  body: InvitePartnerCustomerDto;
}>;


export type InvitePartnerCustomerMutation = { __typename?: 'Mutation', invitePartnerCustomer: { __typename?: 'PartnerCustomerType', id: string } };

export type CancelPartnerCustomerInviteMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type CancelPartnerCustomerInviteMutation = { __typename?: 'Mutation', cancelPartnerCustomerInvite: { __typename?: 'PartnerCustomerType', id: string } };

export type EndPartnerCustomerMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EndPartnerCustomerMutation = { __typename?: 'Mutation', endPartnerCustomer: { __typename?: 'PartnerCustomerType', id: string } };

export type PartnerDashboardRemindersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<PartnerDashboardReminderSort> | PartnerDashboardReminderSort>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceCallDashboardWhere>;
}>;


export type PartnerDashboardRemindersQuery = { __typename?: 'Query', partnerDashboardReminders: { __typename?: 'PartnerDashboardReminderList', totalCount: number, list: Array<{ __typename?: 'PartnerDashboardReminderType', id: string, date: any, title: string, createdAt: any, vehicleId: string, businessName: string, vehicle: { __typename?: 'VehicleType', id: string, name?: string | null, registerNumber?: string | null, VIN?: string | null, brand?: string | null, model?: string | null } }> } };

export type PartnerDashboardFaultsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<PartnerDashboardFaultSort> | PartnerDashboardFaultSort>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  take?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<ServiceCallDashboardWhere>;
}>;


export type PartnerDashboardFaultsQuery = { __typename?: 'Query', partnerDashboardFaults: { __typename?: 'PartnerDashboardFaultList', totalCount: number, list: Array<{ __typename?: 'PartnerDashboardFaultType', id: string, description: string, isDone: boolean, isRead: boolean, createdAt: any, vehicleId: string, businessName: string, vehicle: { __typename?: 'VehicleType', id: string, name?: string | null, registerNumber?: string | null, VIN?: string | null, brand?: string | null, model?: string | null } }> } };

export type PartnerDashboardOverdueRemindersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerDashboardOverdueRemindersQuery = { __typename?: 'Query', partnerDashboardReminders: { __typename?: 'PartnerDashboardReminderList', totalCount: number, list: Array<{ __typename?: 'PartnerDashboardReminderType', date: any }> } };

export type PartnerDashboardReminderTabCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerDashboardReminderTabCountQuery = { __typename?: 'Query', partnerDashboardReminders: { __typename?: 'PartnerDashboardReminderList', totalCount: number } };

export type PartnerDashboardFaultTabCountQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerDashboardFaultTabCountQuery = { __typename?: 'Query', partnerDashboardFaults: { __typename?: 'PartnerDashboardFaultList', totalCount: number } };

export type PartnerDashboardCustomersQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerDashboardCustomersQuery = { __typename?: 'Query', partnerCustomers: { __typename?: 'PartnerCustomerList', totalCount: number, list: Array<{ __typename?: 'PartnerCustomerListItemType', businessId: string, businessName: string }> } };

export type PartnerDashboardVehiclesQueryVariables = Exact<{
  where?: InputMaybe<ServiceCallDashboardWhere>;
}>;


export type PartnerDashboardVehiclesQuery = { __typename?: 'Query', partnerDashboardVehicles: Array<{ __typename?: 'PartnerDashboardVehicleType', id: string, name?: string | null, registerNumber?: string | null, VIN?: string | null, brand?: string | null, model?: string | null, businessId?: string | null }> };

export type PartnerDashboardFaultQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type PartnerDashboardFaultQuery = { __typename?: 'Query', partnerDashboardFault: { __typename?: 'PartnerDashboardFaultType', id: string, description: string, isDone: boolean, isRead: boolean, createdAt: any, vehicleId: string, businessName: string, photo?: string | null, userName?: string | null, vehicle: { __typename?: 'VehicleType', id: string, name?: string | null, registerNumber?: string | null, VIN?: string | null, brand?: string | null, model?: string | null } } };

export type MarkPartnerDashboardFaultReadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkPartnerDashboardFaultReadMutation = { __typename?: 'Mutation', markPartnerDashboardFaultRead: boolean };

export type MarkPartnerDashboardFaultUnreadMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type MarkPartnerDashboardFaultUnreadMutation = { __typename?: 'Mutation', markPartnerDashboardFaultUnread: boolean };

export type ServiceCallAccessStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceCallAccessStatusQuery = { __typename?: 'Query', myServiceCallAccessState: string, partner: { __typename?: 'PartnerType', id: string, hasServiceCallAccess: boolean } };

export type ServiceCallApplySceneUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ServiceCallApplySceneUsersQuery = { __typename?: 'Query', users: { __typename?: 'UserList', list: Array<{ __typename?: 'AdminUserType', id: string, name: string, email: string, level?: string | null, isPartnerAccountOwner: boolean }> } };

export type SubmitServiceCallApplicationMutationVariables = Exact<{
  body: SubmitServiceCallApplicationDto;
}>;


export type SubmitServiceCallApplicationMutation = { __typename?: 'Mutation', submitServiceCallApplication: { __typename?: 'ServiceCallApplicationType', id: string } };

export type CompleteReminderMutationVariables = Exact<{
  body: CompleteReminderDto;
}>;


export type CompleteReminderMutation = { __typename?: 'Mutation', completeReminder: { __typename?: 'CompleteReminderResponse', count: number, ids: Array<string> } };

export type CreateServiceEventMutationVariables = Exact<{
  body: CreateServiceEventDto;
}>;


export type CreateServiceEventMutation = { __typename?: 'Mutation', createServiceEvent: { __typename?: 'ServiceEventType', id: string } };

export type UpdateServiceEventMutationVariables = Exact<{
  id: Scalars['String']['input'];
  body: UpdateServiceEventDto;
}>;


export type UpdateServiceEventMutation = { __typename?: 'Mutation', updateServiceEvent: { __typename?: 'ServiceEventType', id: string } };

export type EditServiceEventQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type EditServiceEventQuery = { __typename?: 'Query', serviceEvent: { __typename?: 'ServiceEventType', type: string, name: string, photo?: string | null, serviceDate: any, mileage?: number | null, runningHours?: number | null, description?: string | null, partnerId?: string | null, isTimeLocked: boolean, attachments: Array<{ __typename?: 'ServiceEventAttachmentType', id: string, name: string, url?: string | null, createdAt: any, canDelete: boolean }>, vehicle: { __typename?: 'VehicleType', hasActiveLicense: boolean } } };

export type ServiceEventQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type ServiceEventQuery = { __typename?: 'Query', serviceEvent: { __typename?: 'ServiceEventType', isTimeLocked: boolean, partnerId?: string | null, type: string, name: string, serviceDate: any, mileage?: number | null, photo?: string | null, runningHours?: number | null, description?: string | null, attachments: Array<{ __typename?: 'ServiceEventAttachmentType', id: string, name: string, url?: string | null, createdAt: any, canDelete: boolean }>, vehicle: { __typename?: 'VehicleType', hasActiveLicense: boolean }, partner?: { __typename?: 'PartnerType', name: string } | null } };

export type DeleteServiceEventAttachmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteServiceEventAttachmentMutation = { __typename?: 'Mutation', deleteServiceEventAttachment: boolean };

export type UpdatePartnerMutationVariables = Exact<{
  body: UpdatePartnerDto;
}>;


export type UpdatePartnerMutation = { __typename?: 'Mutation', updatePartner: { __typename?: 'PartnerType', id: string } };

export type PartnerQueryVariables = Exact<{ [key: string]: never; }>;


export type PartnerQuery = { __typename?: 'Query', partner: { __typename?: 'PartnerType', name: string, photo?: string | null } };

export type ChangeUserInformationMutationVariables = Exact<{
  body: ChangeUserInformationDto;
}>;


export type ChangeUserInformationMutation = { __typename?: 'Mutation', changeUserInformation: { __typename?: 'UserType', id: string } };

export type UserEditWhoAmIQueryVariables = Exact<{ [key: string]: never; }>;


export type UserEditWhoAmIQuery = { __typename?: 'Query', whoAmI: { __typename?: 'UserType', email: string, name: string } };

export type TeamCreateSceneMutationVariables = Exact<{
  body: InviteUserDto;
}>;


export type TeamCreateSceneMutation = { __typename?: 'Mutation', invitePartnerUser: { __typename?: 'UserType', id: string } };

export type TeamIndexSceneQueryVariables = Exact<{ [key: string]: never; }>;


export type TeamIndexSceneQuery = { __typename?: 'Query', users: { __typename?: 'UserList', totalCount: number, list: Array<{ __typename?: 'AdminUserType', id: string, name: string, email: string, level?: string | null, isPartnerAccountOwner: boolean }> } };

export type DeleteUserMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteUserMutation = { __typename?: 'Mutation', deleteUser: { __typename?: 'UserType', id: string } };

export type UpdateUserLevelMutationVariables = Exact<{
  body: UpdateUserLevelDto;
}>;


export type UpdateUserLevelMutation = { __typename?: 'Mutation', updateUserLevel: { __typename?: 'UserType', id: string, level?: string | null } };

export type VehicleShowQueryVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type VehicleShowQuery = { __typename?: 'Query', canSendPartnerServiceCall: boolean, vehicle: { __typename?: 'VehicleType', id: string, token: string, name?: string | null, type?: string | null, registerNumber?: string | null, VIN?: string | null, mileage?: number | null, modelYear?: number | null, commissioning?: any | null, warranty?: any | null, runningHours?: number | null, model?: string | null, brand?: string | null, photo?: string | null, description?: string | null, businessId?: string | null, hasActiveLicense: boolean, attachments: Array<{ __typename?: 'VehicleAttachmentType', id: string, name: string, url?: string | null, createdAt: any, canDelete: boolean }>, reminders: Array<{ __typename?: 'ReminderType', id: string, title: string, date: any, isPartnerLocked: boolean }>, serviceEvents: Array<{ __typename?: 'ServiceEventType', id: string, name: string, serviceDate: any, description?: string | null, isPartnerLocked: boolean, mileage?: number | null, runningHours?: number | null, partner?: { __typename?: 'PartnerType', photo?: string | null } | null }> } };

export type SendPartnerServiceCallMutationVariables = Exact<{
  body: SendPartnerServiceCallDto;
}>;


export type SendPartnerServiceCallMutation = { __typename?: 'Mutation', sendPartnerServiceCall: boolean };

export type DeleteVehicleAttachmentMutationVariables = Exact<{
  id: Scalars['String']['input'];
}>;


export type DeleteVehicleAttachmentMutation = { __typename?: 'Mutation', deleteVehicleAttachment: boolean };


export const CreateCheckoutSessionDocument = gql`
    query CreateCheckoutSession($vehicleId: String!) {
  createCheckoutSession(vehicleId: $vehicleId) {
    url
  }
}
    `;

/**
 * __useCreateCheckoutSessionQuery__
 *
 * To run a query within a React component, call `useCreateCheckoutSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreateCheckoutSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreateCheckoutSessionQuery({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *   },
 * });
 */
export function useCreateCheckoutSessionQuery(baseOptions: Apollo.QueryHookOptions<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables> & ({ variables: CreateCheckoutSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables>(CreateCheckoutSessionDocument, options);
      }
export function useCreateCheckoutSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables>(CreateCheckoutSessionDocument, options);
        }
export function useCreateCheckoutSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables>(CreateCheckoutSessionDocument, options);
        }
export type CreateCheckoutSessionQueryHookResult = ReturnType<typeof useCreateCheckoutSessionQuery>;
export type CreateCheckoutSessionLazyQueryHookResult = ReturnType<typeof useCreateCheckoutSessionLazyQuery>;
export type CreateCheckoutSessionSuspenseQueryHookResult = ReturnType<typeof useCreateCheckoutSessionSuspenseQuery>;
export type CreateCheckoutSessionQueryResult = Apollo.QueryResult<CreateCheckoutSessionQuery, CreateCheckoutSessionQueryVariables>;
export const FindVehicleDocument = gql`
    query FindVehicle($token: String!) {
  searchVehicle(token: $token) {
    id
  }
}
    `;

/**
 * __useFindVehicleQuery__
 *
 * To run a query within a React component, call `useFindVehicleQuery` and pass it any options that fit your needs.
 * When your component renders, `useFindVehicleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFindVehicleQuery({
 *   variables: {
 *      token: // value for 'token'
 *   },
 * });
 */
export function useFindVehicleQuery(baseOptions: Apollo.QueryHookOptions<FindVehicleQuery, FindVehicleQueryVariables> & ({ variables: FindVehicleQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FindVehicleQuery, FindVehicleQueryVariables>(FindVehicleDocument, options);
      }
export function useFindVehicleLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FindVehicleQuery, FindVehicleQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FindVehicleQuery, FindVehicleQueryVariables>(FindVehicleDocument, options);
        }
export function useFindVehicleSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<FindVehicleQuery, FindVehicleQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<FindVehicleQuery, FindVehicleQueryVariables>(FindVehicleDocument, options);
        }
export type FindVehicleQueryHookResult = ReturnType<typeof useFindVehicleQuery>;
export type FindVehicleLazyQueryHookResult = ReturnType<typeof useFindVehicleLazyQuery>;
export type FindVehicleSuspenseQueryHookResult = ReturnType<typeof useFindVehicleSuspenseQuery>;
export type FindVehicleQueryResult = Apollo.QueryResult<FindVehicleQuery, FindVehicleQueryVariables>;
export const ResendConfirmDocument = gql`
    mutation ResendConfirm {
  resendConfirmation {
    status
  }
}
    `;
export type ResendConfirmMutationFn = Apollo.MutationFunction<ResendConfirmMutation, ResendConfirmMutationVariables>;

/**
 * __useResendConfirmMutation__
 *
 * To run a mutation, you first call `useResendConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResendConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resendConfirmMutation, { data, loading, error }] = useResendConfirmMutation({
 *   variables: {
 *   },
 * });
 */
export function useResendConfirmMutation(baseOptions?: Apollo.MutationHookOptions<ResendConfirmMutation, ResendConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResendConfirmMutation, ResendConfirmMutationVariables>(ResendConfirmDocument, options);
      }
export type ResendConfirmMutationHookResult = ReturnType<typeof useResendConfirmMutation>;
export type ResendConfirmMutationResult = Apollo.MutationResult<ResendConfirmMutation>;
export type ResendConfirmMutationOptions = Apollo.BaseMutationOptions<ResendConfirmMutation, ResendConfirmMutationVariables>;
export const SendFeedbackDocument = gql`
    mutation SendFeedback($message: String!) {
  sendFeedback(message: $message) {
    status
  }
}
    `;
export type SendFeedbackMutationFn = Apollo.MutationFunction<SendFeedbackMutation, SendFeedbackMutationVariables>;

/**
 * __useSendFeedbackMutation__
 *
 * To run a mutation, you first call `useSendFeedbackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendFeedbackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendFeedbackMutation, { data, loading, error }] = useSendFeedbackMutation({
 *   variables: {
 *      message: // value for 'message'
 *   },
 * });
 */
export function useSendFeedbackMutation(baseOptions?: Apollo.MutationHookOptions<SendFeedbackMutation, SendFeedbackMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendFeedbackMutation, SendFeedbackMutationVariables>(SendFeedbackDocument, options);
      }
export type SendFeedbackMutationHookResult = ReturnType<typeof useSendFeedbackMutation>;
export type SendFeedbackMutationResult = Apollo.MutationResult<SendFeedbackMutation>;
export type SendFeedbackMutationOptions = Apollo.BaseMutationOptions<SendFeedbackMutation, SendFeedbackMutationVariables>;
export const StripeSceneDocument = gql`
    query StripeScene($id: String!) {
  vehicle(id: $id) {
    id
    licenseExpireDate
  }
}
    `;

/**
 * __useStripeSceneQuery__
 *
 * To run a query within a React component, call `useStripeSceneQuery` and pass it any options that fit your needs.
 * When your component renders, `useStripeSceneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStripeSceneQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useStripeSceneQuery(baseOptions: Apollo.QueryHookOptions<StripeSceneQuery, StripeSceneQueryVariables> & ({ variables: StripeSceneQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StripeSceneQuery, StripeSceneQueryVariables>(StripeSceneDocument, options);
      }
export function useStripeSceneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StripeSceneQuery, StripeSceneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StripeSceneQuery, StripeSceneQueryVariables>(StripeSceneDocument, options);
        }
export function useStripeSceneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StripeSceneQuery, StripeSceneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StripeSceneQuery, StripeSceneQueryVariables>(StripeSceneDocument, options);
        }
export type StripeSceneQueryHookResult = ReturnType<typeof useStripeSceneQuery>;
export type StripeSceneLazyQueryHookResult = ReturnType<typeof useStripeSceneLazyQuery>;
export type StripeSceneSuspenseQueryHookResult = ReturnType<typeof useStripeSceneSuspenseQuery>;
export type StripeSceneQueryResult = Apollo.QueryResult<StripeSceneQuery, StripeSceneQueryVariables>;
export const UseVoucherDocument = gql`
    mutation UseVoucher($vehicleId: String!, $voucher: String!) {
  useVoucher(vehicleId: $vehicleId, voucher: $voucher) {
    id
  }
}
    `;
export type UseVoucherMutationFn = Apollo.MutationFunction<UseVoucherMutation, UseVoucherMutationVariables>;

/**
 * __useUseVoucherMutation__
 *
 * To run a mutation, you first call `useUseVoucherMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUseVoucherMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [useVoucherMutation, { data, loading, error }] = useUseVoucherMutation({
 *   variables: {
 *      vehicleId: // value for 'vehicleId'
 *      voucher: // value for 'voucher'
 *   },
 * });
 */
export function useUseVoucherMutation(baseOptions?: Apollo.MutationHookOptions<UseVoucherMutation, UseVoucherMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UseVoucherMutation, UseVoucherMutationVariables>(UseVoucherDocument, options);
      }
export type UseVoucherMutationHookResult = ReturnType<typeof useUseVoucherMutation>;
export type UseVoucherMutationResult = Apollo.MutationResult<UseVoucherMutation>;
export type UseVoucherMutationOptions = Apollo.BaseMutationOptions<UseVoucherMutation, UseVoucherMutationVariables>;
export const WhoAmIDocument = gql`
    query WhoAmI {
  whoAmI {
    id
    email
    name
    isConfirmed
    level
    isPartnerAccountOwner
    partner {
      id
      name
      photo
      hasServiceCallAccess
    }
  }
}
    `;

/**
 * __useWhoAmIQuery__
 *
 * To run a query within a React component, call `useWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
      }
export function useWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export function useWhoAmISuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WhoAmIQuery, WhoAmIQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WhoAmIQuery, WhoAmIQueryVariables>(WhoAmIDocument, options);
        }
export type WhoAmIQueryHookResult = ReturnType<typeof useWhoAmIQuery>;
export type WhoAmILazyQueryHookResult = ReturnType<typeof useWhoAmILazyQuery>;
export type WhoAmISuspenseQueryHookResult = ReturnType<typeof useWhoAmISuspenseQuery>;
export type WhoAmIQueryResult = Apollo.QueryResult<WhoAmIQuery, WhoAmIQueryVariables>;
export const VerifyAcceptInvitationTokenDocument = gql`
    mutation VerifyAcceptInvitationToken($body: VerifyAcceptInvitationDto!) {
  verifyAcceptInvitationToken(body: $body)
}
    `;
export type VerifyAcceptInvitationTokenMutationFn = Apollo.MutationFunction<VerifyAcceptInvitationTokenMutation, VerifyAcceptInvitationTokenMutationVariables>;

/**
 * __useVerifyAcceptInvitationTokenMutation__
 *
 * To run a mutation, you first call `useVerifyAcceptInvitationTokenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyAcceptInvitationTokenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyAcceptInvitationTokenMutation, { data, loading, error }] = useVerifyAcceptInvitationTokenMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useVerifyAcceptInvitationTokenMutation(baseOptions?: Apollo.MutationHookOptions<VerifyAcceptInvitationTokenMutation, VerifyAcceptInvitationTokenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<VerifyAcceptInvitationTokenMutation, VerifyAcceptInvitationTokenMutationVariables>(VerifyAcceptInvitationTokenDocument, options);
      }
export type VerifyAcceptInvitationTokenMutationHookResult = ReturnType<typeof useVerifyAcceptInvitationTokenMutation>;
export type VerifyAcceptInvitationTokenMutationResult = Apollo.MutationResult<VerifyAcceptInvitationTokenMutation>;
export type VerifyAcceptInvitationTokenMutationOptions = Apollo.BaseMutationOptions<VerifyAcceptInvitationTokenMutation, VerifyAcceptInvitationTokenMutationVariables>;
export const AcceptInvitationDocument = gql`
    mutation AcceptInvitation($body: AcceptInvitationDto!) {
  acceptInvitationToken(body: $body)
}
    `;
export type AcceptInvitationMutationFn = Apollo.MutationFunction<AcceptInvitationMutation, AcceptInvitationMutationVariables>;

/**
 * __useAcceptInvitationMutation__
 *
 * To run a mutation, you first call `useAcceptInvitationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcceptInvitationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acceptInvitationMutation, { data, loading, error }] = useAcceptInvitationMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useAcceptInvitationMutation(baseOptions?: Apollo.MutationHookOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AcceptInvitationMutation, AcceptInvitationMutationVariables>(AcceptInvitationDocument, options);
      }
export type AcceptInvitationMutationHookResult = ReturnType<typeof useAcceptInvitationMutation>;
export type AcceptInvitationMutationResult = Apollo.MutationResult<AcceptInvitationMutation>;
export type AcceptInvitationMutationOptions = Apollo.BaseMutationOptions<AcceptInvitationMutation, AcceptInvitationMutationVariables>;
export const ConfirmDocument = gql`
    mutation Confirm($body: ConfirmDto!) {
  confirm(body: $body) {
    status
  }
}
    `;
export type ConfirmMutationFn = Apollo.MutationFunction<ConfirmMutation, ConfirmMutationVariables>;

/**
 * __useConfirmMutation__
 *
 * To run a mutation, you first call `useConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [confirmMutation, { data, loading, error }] = useConfirmMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useConfirmMutation(baseOptions?: Apollo.MutationHookOptions<ConfirmMutation, ConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ConfirmMutation, ConfirmMutationVariables>(ConfirmDocument, options);
      }
export type ConfirmMutationHookResult = ReturnType<typeof useConfirmMutation>;
export type ConfirmMutationResult = Apollo.MutationResult<ConfirmMutation>;
export type ConfirmMutationOptions = Apollo.BaseMutationOptions<ConfirmMutation, ConfirmMutationVariables>;
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($body: ForgotPasswordDto!) {
  forgotPasswordPartner(body: $body) {
    status
  }
}
    `;
export type ForgotPasswordMutationFn = Apollo.MutationFunction<ForgotPasswordMutation, ForgotPasswordMutationVariables>;

/**
 * __useForgotPasswordMutation__
 *
 * To run a mutation, you first call `useForgotPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useForgotPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [forgotPasswordMutation, { data, loading, error }] = useForgotPasswordMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useForgotPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ForgotPasswordMutation, ForgotPasswordMutationVariables>(ForgotPasswordDocument, options);
      }
export type ForgotPasswordMutationHookResult = ReturnType<typeof useForgotPasswordMutation>;
export type ForgotPasswordMutationResult = Apollo.MutationResult<ForgotPasswordMutation>;
export type ForgotPasswordMutationOptions = Apollo.BaseMutationOptions<ForgotPasswordMutation, ForgotPasswordMutationVariables>;
export const LoginDocument = gql`
    mutation Login($body: LoginDto!) {
  loginPartner(body: $body) {
    token
    user {
      id
      name
    }
  }
}
    `;
export type LoginMutationFn = Apollo.MutationFunction<LoginMutation, LoginMutationVariables>;

/**
 * __useLoginMutation__
 *
 * To run a mutation, you first call `useLoginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useLoginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [loginMutation, { data, loading, error }] = useLoginMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useLoginMutation(baseOptions?: Apollo.MutationHookOptions<LoginMutation, LoginMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<LoginMutation, LoginMutationVariables>(LoginDocument, options);
      }
export type LoginMutationHookResult = ReturnType<typeof useLoginMutation>;
export type LoginMutationResult = Apollo.MutationResult<LoginMutation>;
export type LoginMutationOptions = Apollo.BaseMutationOptions<LoginMutation, LoginMutationVariables>;
export const RegisterPartnerDocument = gql`
    mutation RegisterPartner($body: RegisterPartnerUserDto!) {
  registerPartnerUser(body: $body) {
    token
  }
}
    `;
export type RegisterPartnerMutationFn = Apollo.MutationFunction<RegisterPartnerMutation, RegisterPartnerMutationVariables>;

/**
 * __useRegisterPartnerMutation__
 *
 * To run a mutation, you first call `useRegisterPartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterPartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerPartnerMutation, { data, loading, error }] = useRegisterPartnerMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useRegisterPartnerMutation(baseOptions?: Apollo.MutationHookOptions<RegisterPartnerMutation, RegisterPartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RegisterPartnerMutation, RegisterPartnerMutationVariables>(RegisterPartnerDocument, options);
      }
export type RegisterPartnerMutationHookResult = ReturnType<typeof useRegisterPartnerMutation>;
export type RegisterPartnerMutationResult = Apollo.MutationResult<RegisterPartnerMutation>;
export type RegisterPartnerMutationOptions = Apollo.BaseMutationOptions<RegisterPartnerMutation, RegisterPartnerMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($body: ResetPasswordDto!) {
  resetPassword(body: $body) {
    status
  }
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const ValidateResetTokenDocument = gql`
    query ValidateResetToken($body: ValidateResetTokenDto!) {
  validateResetToken(body: $body) {
    status
  }
}
    `;

/**
 * __useValidateResetTokenQuery__
 *
 * To run a query within a React component, call `useValidateResetTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useValidateResetTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useValidateResetTokenQuery({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useValidateResetTokenQuery(baseOptions: Apollo.QueryHookOptions<ValidateResetTokenQuery, ValidateResetTokenQueryVariables> & ({ variables: ValidateResetTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ValidateResetTokenQuery, ValidateResetTokenQueryVariables>(ValidateResetTokenDocument, options);
      }
export function useValidateResetTokenLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ValidateResetTokenQuery, ValidateResetTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ValidateResetTokenQuery, ValidateResetTokenQueryVariables>(ValidateResetTokenDocument, options);
        }
export function useValidateResetTokenSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ValidateResetTokenQuery, ValidateResetTokenQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ValidateResetTokenQuery, ValidateResetTokenQueryVariables>(ValidateResetTokenDocument, options);
        }
export type ValidateResetTokenQueryHookResult = ReturnType<typeof useValidateResetTokenQuery>;
export type ValidateResetTokenLazyQueryHookResult = ReturnType<typeof useValidateResetTokenLazyQuery>;
export type ValidateResetTokenSuspenseQueryHookResult = ReturnType<typeof useValidateResetTokenSuspenseQuery>;
export type ValidateResetTokenQueryResult = Apollo.QueryResult<ValidateResetTokenQuery, ValidateResetTokenQueryVariables>;
export const CreateReminderDocument = gql`
    mutation CreateReminder($body: CreateReminderDto!) {
  createReminder(body: $body) {
    id
  }
}
    `;
export type CreateReminderMutationFn = Apollo.MutationFunction<CreateReminderMutation, CreateReminderMutationVariables>;

/**
 * __useCreateReminderMutation__
 *
 * To run a mutation, you first call `useCreateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReminderMutation, { data, loading, error }] = useCreateReminderMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateReminderMutation(baseOptions?: Apollo.MutationHookOptions<CreateReminderMutation, CreateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateReminderMutation, CreateReminderMutationVariables>(CreateReminderDocument, options);
      }
export type CreateReminderMutationHookResult = ReturnType<typeof useCreateReminderMutation>;
export type CreateReminderMutationResult = Apollo.MutationResult<CreateReminderMutation>;
export type CreateReminderMutationOptions = Apollo.BaseMutationOptions<CreateReminderMutation, CreateReminderMutationVariables>;
export const UpdateReminderDocument = gql`
    mutation UpdateReminder($id: String!, $body: UpdateReminderDto!) {
  updateReminder(id: $id, body: $body) {
    id
  }
}
    `;
export type UpdateReminderMutationFn = Apollo.MutationFunction<UpdateReminderMutation, UpdateReminderMutationVariables>;

/**
 * __useUpdateReminderMutation__
 *
 * To run a mutation, you first call `useUpdateReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateReminderMutation, { data, loading, error }] = useUpdateReminderMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateReminderMutation(baseOptions?: Apollo.MutationHookOptions<UpdateReminderMutation, UpdateReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateReminderMutation, UpdateReminderMutationVariables>(UpdateReminderDocument, options);
      }
export type UpdateReminderMutationHookResult = ReturnType<typeof useUpdateReminderMutation>;
export type UpdateReminderMutationResult = Apollo.MutationResult<UpdateReminderMutation>;
export type UpdateReminderMutationOptions = Apollo.BaseMutationOptions<UpdateReminderMutation, UpdateReminderMutationVariables>;
export const ReminderDocument = gql`
    query Reminder($id: String!) {
  reminder(id: $id) {
    title
    date
  }
}
    `;

/**
 * __useReminderQuery__
 *
 * To run a query within a React component, call `useReminderQuery` and pass it any options that fit your needs.
 * When your component renders, `useReminderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useReminderQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useReminderQuery(baseOptions: Apollo.QueryHookOptions<ReminderQuery, ReminderQueryVariables> & ({ variables: ReminderQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ReminderQuery, ReminderQueryVariables>(ReminderDocument, options);
      }
export function useReminderLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ReminderQuery, ReminderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ReminderQuery, ReminderQueryVariables>(ReminderDocument, options);
        }
export function useReminderSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ReminderQuery, ReminderQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ReminderQuery, ReminderQueryVariables>(ReminderDocument, options);
        }
export type ReminderQueryHookResult = ReturnType<typeof useReminderQuery>;
export type ReminderLazyQueryHookResult = ReturnType<typeof useReminderLazyQuery>;
export type ReminderSuspenseQueryHookResult = ReturnType<typeof useReminderSuspenseQuery>;
export type ReminderQueryResult = Apollo.QueryResult<ReminderQuery, ReminderQueryVariables>;
export const RemindersDocument = gql`
    query Reminders($orderBy: [ReminderSort!], $skip: Int, $take: Int, $where: ReminderWhere) {
  reminders(orderBy: $orderBy, skip: $skip, take: $take, where: $where) {
    totalCount
    list {
      id
      title
      date
      vehicleId
      vehicle {
        id
        name
        registerNumber
        VIN
        brand
        model
      }
    }
  }
}
    `;

/**
 * __useRemindersQuery__
 *
 * To run a query within a React component, call `useRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `useRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRemindersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function useRemindersQuery(baseOptions?: Apollo.QueryHookOptions<RemindersQuery, RemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<RemindersQuery, RemindersQueryVariables>(RemindersDocument, options);
      }
export function useRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<RemindersQuery, RemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<RemindersQuery, RemindersQueryVariables>(RemindersDocument, options);
        }
export function useRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<RemindersQuery, RemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<RemindersQuery, RemindersQueryVariables>(RemindersDocument, options);
        }
export type RemindersQueryHookResult = ReturnType<typeof useRemindersQuery>;
export type RemindersLazyQueryHookResult = ReturnType<typeof useRemindersLazyQuery>;
export type RemindersSuspenseQueryHookResult = ReturnType<typeof useRemindersSuspenseQuery>;
export type RemindersQueryResult = Apollo.QueryResult<RemindersQuery, RemindersQueryVariables>;
export const CreatePartnerCustomerVehicleDocument = gql`
    mutation CreatePartnerCustomerVehicle($businessId: String!, $body: CreateVehicleDto!) {
  createPartnerCustomerVehicle(businessId: $businessId, body: $body) {
    id
  }
}
    `;
export type CreatePartnerCustomerVehicleMutationFn = Apollo.MutationFunction<CreatePartnerCustomerVehicleMutation, CreatePartnerCustomerVehicleMutationVariables>;

/**
 * __useCreatePartnerCustomerVehicleMutation__
 *
 * To run a mutation, you first call `useCreatePartnerCustomerVehicleMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePartnerCustomerVehicleMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPartnerCustomerVehicleMutation, { data, loading, error }] = useCreatePartnerCustomerVehicleMutation({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreatePartnerCustomerVehicleMutation(baseOptions?: Apollo.MutationHookOptions<CreatePartnerCustomerVehicleMutation, CreatePartnerCustomerVehicleMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePartnerCustomerVehicleMutation, CreatePartnerCustomerVehicleMutationVariables>(CreatePartnerCustomerVehicleDocument, options);
      }
export type CreatePartnerCustomerVehicleMutationHookResult = ReturnType<typeof useCreatePartnerCustomerVehicleMutation>;
export type CreatePartnerCustomerVehicleMutationResult = Apollo.MutationResult<CreatePartnerCustomerVehicleMutation>;
export type CreatePartnerCustomerVehicleMutationOptions = Apollo.BaseMutationOptions<CreatePartnerCustomerVehicleMutation, CreatePartnerCustomerVehicleMutationVariables>;
export const PartnerCustomerVehiclesDocument = gql`
    query PartnerCustomerVehicles($businessId: String!, $orderBy: [PartnerCustomerVehicleSort!], $skip: Int, $take: Int) {
  partnerCustomerVehicles(
    businessId: $businessId
    orderBy: $orderBy
    skip: $skip
    take: $take
  ) {
    businessName
    totalCount
    list {
      id
      name
      registerNumber
      model
      brand
      licenseExpireDate
      licenseStatus
      VIN
    }
  }
}
    `;

/**
 * __usePartnerCustomerVehiclesQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerVehiclesQuery({
 *   variables: {
 *      businessId: // value for 'businessId'
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePartnerCustomerVehiclesQuery(baseOptions: Apollo.QueryHookOptions<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables> & ({ variables: PartnerCustomerVehiclesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables>(PartnerCustomerVehiclesDocument, options);
      }
export function usePartnerCustomerVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables>(PartnerCustomerVehiclesDocument, options);
        }
export function usePartnerCustomerVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables>(PartnerCustomerVehiclesDocument, options);
        }
export type PartnerCustomerVehiclesQueryHookResult = ReturnType<typeof usePartnerCustomerVehiclesQuery>;
export type PartnerCustomerVehiclesLazyQueryHookResult = ReturnType<typeof usePartnerCustomerVehiclesLazyQuery>;
export type PartnerCustomerVehiclesSuspenseQueryHookResult = ReturnType<typeof usePartnerCustomerVehiclesSuspenseQuery>;
export type PartnerCustomerVehiclesQueryResult = Apollo.QueryResult<PartnerCustomerVehiclesQuery, PartnerCustomerVehiclesQueryVariables>;
export const PartnerCustomersDocument = gql`
    query PartnerCustomers($orderBy: [PartnerCustomerSort!], $skip: Int, $take: Int) {
  partnerCustomers(orderBy: $orderBy, skip: $skip, take: $take) {
    totalCount
    list {
      id
      businessId
      status
      startedAt
      businessName
      vehicleCount
    }
  }
}
    `;

/**
 * __usePartnerCustomersQuery__
 *
 * To run a query within a React component, call `usePartnerCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *   },
 * });
 */
export function usePartnerCustomersQuery(baseOptions?: Apollo.QueryHookOptions<PartnerCustomersQuery, PartnerCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerCustomersQuery, PartnerCustomersQueryVariables>(PartnerCustomersDocument, options);
      }
export function usePartnerCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerCustomersQuery, PartnerCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerCustomersQuery, PartnerCustomersQueryVariables>(PartnerCustomersDocument, options);
        }
export function usePartnerCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerCustomersQuery, PartnerCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerCustomersQuery, PartnerCustomersQueryVariables>(PartnerCustomersDocument, options);
        }
export type PartnerCustomersQueryHookResult = ReturnType<typeof usePartnerCustomersQuery>;
export type PartnerCustomersLazyQueryHookResult = ReturnType<typeof usePartnerCustomersLazyQuery>;
export type PartnerCustomersSuspenseQueryHookResult = ReturnType<typeof usePartnerCustomersSuspenseQuery>;
export type PartnerCustomersQueryResult = Apollo.QueryResult<PartnerCustomersQuery, PartnerCustomersQueryVariables>;
export const PartnerCustomerInvitesDocument = gql`
    query PartnerCustomerInvites {
  partnerCustomerInvites {
    id
    businessId
    createdAt
    businessName
    email
  }
}
    `;

/**
 * __usePartnerCustomerInvitesQuery__
 *
 * To run a query within a React component, call `usePartnerCustomerInvitesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerCustomerInvitesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerCustomerInvitesQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerCustomerInvitesQuery(baseOptions?: Apollo.QueryHookOptions<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>(PartnerCustomerInvitesDocument, options);
      }
export function usePartnerCustomerInvitesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>(PartnerCustomerInvitesDocument, options);
        }
export function usePartnerCustomerInvitesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>(PartnerCustomerInvitesDocument, options);
        }
export type PartnerCustomerInvitesQueryHookResult = ReturnType<typeof usePartnerCustomerInvitesQuery>;
export type PartnerCustomerInvitesLazyQueryHookResult = ReturnType<typeof usePartnerCustomerInvitesLazyQuery>;
export type PartnerCustomerInvitesSuspenseQueryHookResult = ReturnType<typeof usePartnerCustomerInvitesSuspenseQuery>;
export type PartnerCustomerInvitesQueryResult = Apollo.QueryResult<PartnerCustomerInvitesQuery, PartnerCustomerInvitesQueryVariables>;
export const InvitePartnerCustomerDocument = gql`
    mutation InvitePartnerCustomer($body: InvitePartnerCustomerDto!) {
  invitePartnerCustomer(body: $body) {
    id
  }
}
    `;
export type InvitePartnerCustomerMutationFn = Apollo.MutationFunction<InvitePartnerCustomerMutation, InvitePartnerCustomerMutationVariables>;

/**
 * __useInvitePartnerCustomerMutation__
 *
 * To run a mutation, you first call `useInvitePartnerCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInvitePartnerCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [invitePartnerCustomerMutation, { data, loading, error }] = useInvitePartnerCustomerMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useInvitePartnerCustomerMutation(baseOptions?: Apollo.MutationHookOptions<InvitePartnerCustomerMutation, InvitePartnerCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InvitePartnerCustomerMutation, InvitePartnerCustomerMutationVariables>(InvitePartnerCustomerDocument, options);
      }
export type InvitePartnerCustomerMutationHookResult = ReturnType<typeof useInvitePartnerCustomerMutation>;
export type InvitePartnerCustomerMutationResult = Apollo.MutationResult<InvitePartnerCustomerMutation>;
export type InvitePartnerCustomerMutationOptions = Apollo.BaseMutationOptions<InvitePartnerCustomerMutation, InvitePartnerCustomerMutationVariables>;
export const CancelPartnerCustomerInviteDocument = gql`
    mutation CancelPartnerCustomerInvite($id: String!) {
  cancelPartnerCustomerInvite(id: $id) {
    id
  }
}
    `;
export type CancelPartnerCustomerInviteMutationFn = Apollo.MutationFunction<CancelPartnerCustomerInviteMutation, CancelPartnerCustomerInviteMutationVariables>;

/**
 * __useCancelPartnerCustomerInviteMutation__
 *
 * To run a mutation, you first call `useCancelPartnerCustomerInviteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelPartnerCustomerInviteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelPartnerCustomerInviteMutation, { data, loading, error }] = useCancelPartnerCustomerInviteMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useCancelPartnerCustomerInviteMutation(baseOptions?: Apollo.MutationHookOptions<CancelPartnerCustomerInviteMutation, CancelPartnerCustomerInviteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelPartnerCustomerInviteMutation, CancelPartnerCustomerInviteMutationVariables>(CancelPartnerCustomerInviteDocument, options);
      }
export type CancelPartnerCustomerInviteMutationHookResult = ReturnType<typeof useCancelPartnerCustomerInviteMutation>;
export type CancelPartnerCustomerInviteMutationResult = Apollo.MutationResult<CancelPartnerCustomerInviteMutation>;
export type CancelPartnerCustomerInviteMutationOptions = Apollo.BaseMutationOptions<CancelPartnerCustomerInviteMutation, CancelPartnerCustomerInviteMutationVariables>;
export const EndPartnerCustomerDocument = gql`
    mutation EndPartnerCustomer($id: String!) {
  endPartnerCustomer(id: $id) {
    id
  }
}
    `;
export type EndPartnerCustomerMutationFn = Apollo.MutationFunction<EndPartnerCustomerMutation, EndPartnerCustomerMutationVariables>;

/**
 * __useEndPartnerCustomerMutation__
 *
 * To run a mutation, you first call `useEndPartnerCustomerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEndPartnerCustomerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [endPartnerCustomerMutation, { data, loading, error }] = useEndPartnerCustomerMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEndPartnerCustomerMutation(baseOptions?: Apollo.MutationHookOptions<EndPartnerCustomerMutation, EndPartnerCustomerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<EndPartnerCustomerMutation, EndPartnerCustomerMutationVariables>(EndPartnerCustomerDocument, options);
      }
export type EndPartnerCustomerMutationHookResult = ReturnType<typeof useEndPartnerCustomerMutation>;
export type EndPartnerCustomerMutationResult = Apollo.MutationResult<EndPartnerCustomerMutation>;
export type EndPartnerCustomerMutationOptions = Apollo.BaseMutationOptions<EndPartnerCustomerMutation, EndPartnerCustomerMutationVariables>;
export const PartnerDashboardRemindersDocument = gql`
    query PartnerDashboardReminders($orderBy: [PartnerDashboardReminderSort!], $skip: Int, $take: Int, $where: ServiceCallDashboardWhere) {
  partnerDashboardReminders(
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: $where
  ) {
    totalCount
    list {
      id
      date
      title
      createdAt
      vehicleId
      businessName
      vehicle {
        id
        name
        registerNumber
        VIN
        brand
        model
      }
    }
  }
}
    `;

/**
 * __usePartnerDashboardRemindersQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardRemindersQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePartnerDashboardRemindersQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>(PartnerDashboardRemindersDocument, options);
      }
export function usePartnerDashboardRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>(PartnerDashboardRemindersDocument, options);
        }
export function usePartnerDashboardRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>(PartnerDashboardRemindersDocument, options);
        }
export type PartnerDashboardRemindersQueryHookResult = ReturnType<typeof usePartnerDashboardRemindersQuery>;
export type PartnerDashboardRemindersLazyQueryHookResult = ReturnType<typeof usePartnerDashboardRemindersLazyQuery>;
export type PartnerDashboardRemindersSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardRemindersSuspenseQuery>;
export type PartnerDashboardRemindersQueryResult = Apollo.QueryResult<PartnerDashboardRemindersQuery, PartnerDashboardRemindersQueryVariables>;
export const PartnerDashboardFaultsDocument = gql`
    query PartnerDashboardFaults($orderBy: [PartnerDashboardFaultSort!], $skip: Int, $take: Int, $where: ServiceCallDashboardWhere) {
  partnerDashboardFaults(
    orderBy: $orderBy
    skip: $skip
    take: $take
    where: $where
  ) {
    totalCount
    list {
      id
      description
      isDone
      isRead
      createdAt
      vehicleId
      businessName
      vehicle {
        id
        name
        registerNumber
        VIN
        brand
        model
      }
    }
  }
}
    `;

/**
 * __usePartnerDashboardFaultsQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardFaultsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardFaultsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardFaultsQuery({
 *   variables: {
 *      orderBy: // value for 'orderBy'
 *      skip: // value for 'skip'
 *      take: // value for 'take'
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePartnerDashboardFaultsQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>(PartnerDashboardFaultsDocument, options);
      }
export function usePartnerDashboardFaultsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>(PartnerDashboardFaultsDocument, options);
        }
export function usePartnerDashboardFaultsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>(PartnerDashboardFaultsDocument, options);
        }
export type PartnerDashboardFaultsQueryHookResult = ReturnType<typeof usePartnerDashboardFaultsQuery>;
export type PartnerDashboardFaultsLazyQueryHookResult = ReturnType<typeof usePartnerDashboardFaultsLazyQuery>;
export type PartnerDashboardFaultsSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardFaultsSuspenseQuery>;
export type PartnerDashboardFaultsQueryResult = Apollo.QueryResult<PartnerDashboardFaultsQuery, PartnerDashboardFaultsQueryVariables>;
export const PartnerDashboardOverdueRemindersDocument = gql`
    query PartnerDashboardOverdueReminders {
  partnerDashboardReminders(take: 200, orderBy: [{date: "asc"}]) {
    totalCount
    list {
      date
    }
  }
}
    `;

/**
 * __usePartnerDashboardOverdueRemindersQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardOverdueRemindersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardOverdueRemindersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardOverdueRemindersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerDashboardOverdueRemindersQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>(PartnerDashboardOverdueRemindersDocument, options);
      }
export function usePartnerDashboardOverdueRemindersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>(PartnerDashboardOverdueRemindersDocument, options);
        }
export function usePartnerDashboardOverdueRemindersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>(PartnerDashboardOverdueRemindersDocument, options);
        }
export type PartnerDashboardOverdueRemindersQueryHookResult = ReturnType<typeof usePartnerDashboardOverdueRemindersQuery>;
export type PartnerDashboardOverdueRemindersLazyQueryHookResult = ReturnType<typeof usePartnerDashboardOverdueRemindersLazyQuery>;
export type PartnerDashboardOverdueRemindersSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardOverdueRemindersSuspenseQuery>;
export type PartnerDashboardOverdueRemindersQueryResult = Apollo.QueryResult<PartnerDashboardOverdueRemindersQuery, PartnerDashboardOverdueRemindersQueryVariables>;
export const PartnerDashboardReminderTabCountDocument = gql`
    query PartnerDashboardReminderTabCount {
  partnerDashboardReminders(take: 0) {
    totalCount
  }
}
    `;

/**
 * __usePartnerDashboardReminderTabCountQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardReminderTabCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardReminderTabCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardReminderTabCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerDashboardReminderTabCountQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>(PartnerDashboardReminderTabCountDocument, options);
      }
export function usePartnerDashboardReminderTabCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>(PartnerDashboardReminderTabCountDocument, options);
        }
export function usePartnerDashboardReminderTabCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>(PartnerDashboardReminderTabCountDocument, options);
        }
export type PartnerDashboardReminderTabCountQueryHookResult = ReturnType<typeof usePartnerDashboardReminderTabCountQuery>;
export type PartnerDashboardReminderTabCountLazyQueryHookResult = ReturnType<typeof usePartnerDashboardReminderTabCountLazyQuery>;
export type PartnerDashboardReminderTabCountSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardReminderTabCountSuspenseQuery>;
export type PartnerDashboardReminderTabCountQueryResult = Apollo.QueryResult<PartnerDashboardReminderTabCountQuery, PartnerDashboardReminderTabCountQueryVariables>;
export const PartnerDashboardFaultTabCountDocument = gql`
    query PartnerDashboardFaultTabCount {
  partnerDashboardFaults(take: 0) {
    totalCount
  }
}
    `;

/**
 * __usePartnerDashboardFaultTabCountQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardFaultTabCountQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardFaultTabCountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardFaultTabCountQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerDashboardFaultTabCountQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>(PartnerDashboardFaultTabCountDocument, options);
      }
export function usePartnerDashboardFaultTabCountLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>(PartnerDashboardFaultTabCountDocument, options);
        }
export function usePartnerDashboardFaultTabCountSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>(PartnerDashboardFaultTabCountDocument, options);
        }
export type PartnerDashboardFaultTabCountQueryHookResult = ReturnType<typeof usePartnerDashboardFaultTabCountQuery>;
export type PartnerDashboardFaultTabCountLazyQueryHookResult = ReturnType<typeof usePartnerDashboardFaultTabCountLazyQuery>;
export type PartnerDashboardFaultTabCountSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardFaultTabCountSuspenseQuery>;
export type PartnerDashboardFaultTabCountQueryResult = Apollo.QueryResult<PartnerDashboardFaultTabCountQuery, PartnerDashboardFaultTabCountQueryVariables>;
export const PartnerDashboardCustomersDocument = gql`
    query PartnerDashboardCustomers {
  partnerCustomers {
    totalCount
    list {
      businessId
      businessName
    }
  }
}
    `;

/**
 * __usePartnerDashboardCustomersQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardCustomersQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerDashboardCustomersQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>(PartnerDashboardCustomersDocument, options);
      }
export function usePartnerDashboardCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>(PartnerDashboardCustomersDocument, options);
        }
export function usePartnerDashboardCustomersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>(PartnerDashboardCustomersDocument, options);
        }
export type PartnerDashboardCustomersQueryHookResult = ReturnType<typeof usePartnerDashboardCustomersQuery>;
export type PartnerDashboardCustomersLazyQueryHookResult = ReturnType<typeof usePartnerDashboardCustomersLazyQuery>;
export type PartnerDashboardCustomersSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardCustomersSuspenseQuery>;
export type PartnerDashboardCustomersQueryResult = Apollo.QueryResult<PartnerDashboardCustomersQuery, PartnerDashboardCustomersQueryVariables>;
export const PartnerDashboardVehiclesDocument = gql`
    query PartnerDashboardVehicles($where: ServiceCallDashboardWhere) {
  partnerDashboardVehicles(where: $where) {
    id
    name
    registerNumber
    VIN
    brand
    model
    businessId
  }
}
    `;

/**
 * __usePartnerDashboardVehiclesQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardVehiclesQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardVehiclesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardVehiclesQuery({
 *   variables: {
 *      where: // value for 'where'
 *   },
 * });
 */
export function usePartnerDashboardVehiclesQuery(baseOptions?: Apollo.QueryHookOptions<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>(PartnerDashboardVehiclesDocument, options);
      }
export function usePartnerDashboardVehiclesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>(PartnerDashboardVehiclesDocument, options);
        }
export function usePartnerDashboardVehiclesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>(PartnerDashboardVehiclesDocument, options);
        }
export type PartnerDashboardVehiclesQueryHookResult = ReturnType<typeof usePartnerDashboardVehiclesQuery>;
export type PartnerDashboardVehiclesLazyQueryHookResult = ReturnType<typeof usePartnerDashboardVehiclesLazyQuery>;
export type PartnerDashboardVehiclesSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardVehiclesSuspenseQuery>;
export type PartnerDashboardVehiclesQueryResult = Apollo.QueryResult<PartnerDashboardVehiclesQuery, PartnerDashboardVehiclesQueryVariables>;
export const PartnerDashboardFaultDocument = gql`
    query PartnerDashboardFault($id: String!) {
  partnerDashboardFault(id: $id) {
    id
    description
    isDone
    isRead
    createdAt
    vehicleId
    businessName
    photo
    userName
    vehicle {
      id
      name
      registerNumber
      VIN
      brand
      model
    }
  }
}
    `;

/**
 * __usePartnerDashboardFaultQuery__
 *
 * To run a query within a React component, call `usePartnerDashboardFaultQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerDashboardFaultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerDashboardFaultQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function usePartnerDashboardFaultQuery(baseOptions: Apollo.QueryHookOptions<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables> & ({ variables: PartnerDashboardFaultQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables>(PartnerDashboardFaultDocument, options);
      }
export function usePartnerDashboardFaultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables>(PartnerDashboardFaultDocument, options);
        }
export function usePartnerDashboardFaultSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables>(PartnerDashboardFaultDocument, options);
        }
export type PartnerDashboardFaultQueryHookResult = ReturnType<typeof usePartnerDashboardFaultQuery>;
export type PartnerDashboardFaultLazyQueryHookResult = ReturnType<typeof usePartnerDashboardFaultLazyQuery>;
export type PartnerDashboardFaultSuspenseQueryHookResult = ReturnType<typeof usePartnerDashboardFaultSuspenseQuery>;
export type PartnerDashboardFaultQueryResult = Apollo.QueryResult<PartnerDashboardFaultQuery, PartnerDashboardFaultQueryVariables>;
export const MarkPartnerDashboardFaultReadDocument = gql`
    mutation MarkPartnerDashboardFaultRead($id: String!) {
  markPartnerDashboardFaultRead(id: $id)
}
    `;
export type MarkPartnerDashboardFaultReadMutationFn = Apollo.MutationFunction<MarkPartnerDashboardFaultReadMutation, MarkPartnerDashboardFaultReadMutationVariables>;

/**
 * __useMarkPartnerDashboardFaultReadMutation__
 *
 * To run a mutation, you first call `useMarkPartnerDashboardFaultReadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPartnerDashboardFaultReadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPartnerDashboardFaultReadMutation, { data, loading, error }] = useMarkPartnerDashboardFaultReadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkPartnerDashboardFaultReadMutation(baseOptions?: Apollo.MutationHookOptions<MarkPartnerDashboardFaultReadMutation, MarkPartnerDashboardFaultReadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPartnerDashboardFaultReadMutation, MarkPartnerDashboardFaultReadMutationVariables>(MarkPartnerDashboardFaultReadDocument, options);
      }
export type MarkPartnerDashboardFaultReadMutationHookResult = ReturnType<typeof useMarkPartnerDashboardFaultReadMutation>;
export type MarkPartnerDashboardFaultReadMutationResult = Apollo.MutationResult<MarkPartnerDashboardFaultReadMutation>;
export type MarkPartnerDashboardFaultReadMutationOptions = Apollo.BaseMutationOptions<MarkPartnerDashboardFaultReadMutation, MarkPartnerDashboardFaultReadMutationVariables>;
export const MarkPartnerDashboardFaultUnreadDocument = gql`
    mutation MarkPartnerDashboardFaultUnread($id: String!) {
  markPartnerDashboardFaultUnread(id: $id)
}
    `;
export type MarkPartnerDashboardFaultUnreadMutationFn = Apollo.MutationFunction<MarkPartnerDashboardFaultUnreadMutation, MarkPartnerDashboardFaultUnreadMutationVariables>;

/**
 * __useMarkPartnerDashboardFaultUnreadMutation__
 *
 * To run a mutation, you first call `useMarkPartnerDashboardFaultUnreadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPartnerDashboardFaultUnreadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPartnerDashboardFaultUnreadMutation, { data, loading, error }] = useMarkPartnerDashboardFaultUnreadMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useMarkPartnerDashboardFaultUnreadMutation(baseOptions?: Apollo.MutationHookOptions<MarkPartnerDashboardFaultUnreadMutation, MarkPartnerDashboardFaultUnreadMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkPartnerDashboardFaultUnreadMutation, MarkPartnerDashboardFaultUnreadMutationVariables>(MarkPartnerDashboardFaultUnreadDocument, options);
      }
export type MarkPartnerDashboardFaultUnreadMutationHookResult = ReturnType<typeof useMarkPartnerDashboardFaultUnreadMutation>;
export type MarkPartnerDashboardFaultUnreadMutationResult = Apollo.MutationResult<MarkPartnerDashboardFaultUnreadMutation>;
export type MarkPartnerDashboardFaultUnreadMutationOptions = Apollo.BaseMutationOptions<MarkPartnerDashboardFaultUnreadMutation, MarkPartnerDashboardFaultUnreadMutationVariables>;
export const ServiceCallAccessStatusDocument = gql`
    query ServiceCallAccessStatus {
  partner {
    id
    hasServiceCallAccess
  }
  myServiceCallAccessState
}
    `;

/**
 * __useServiceCallAccessStatusQuery__
 *
 * To run a query within a React component, call `useServiceCallAccessStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCallAccessStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCallAccessStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceCallAccessStatusQuery(baseOptions?: Apollo.QueryHookOptions<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>(ServiceCallAccessStatusDocument, options);
      }
export function useServiceCallAccessStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>(ServiceCallAccessStatusDocument, options);
        }
export function useServiceCallAccessStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>(ServiceCallAccessStatusDocument, options);
        }
export type ServiceCallAccessStatusQueryHookResult = ReturnType<typeof useServiceCallAccessStatusQuery>;
export type ServiceCallAccessStatusLazyQueryHookResult = ReturnType<typeof useServiceCallAccessStatusLazyQuery>;
export type ServiceCallAccessStatusSuspenseQueryHookResult = ReturnType<typeof useServiceCallAccessStatusSuspenseQuery>;
export type ServiceCallAccessStatusQueryResult = Apollo.QueryResult<ServiceCallAccessStatusQuery, ServiceCallAccessStatusQueryVariables>;
export const ServiceCallApplySceneUsersDocument = gql`
    query ServiceCallApplySceneUsers {
  users {
    list {
      id
      name
      email
      level
      isPartnerAccountOwner
    }
  }
}
    `;

/**
 * __useServiceCallApplySceneUsersQuery__
 *
 * To run a query within a React component, call `useServiceCallApplySceneUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceCallApplySceneUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceCallApplySceneUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useServiceCallApplySceneUsersQuery(baseOptions?: Apollo.QueryHookOptions<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>(ServiceCallApplySceneUsersDocument, options);
      }
export function useServiceCallApplySceneUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>(ServiceCallApplySceneUsersDocument, options);
        }
export function useServiceCallApplySceneUsersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>(ServiceCallApplySceneUsersDocument, options);
        }
export type ServiceCallApplySceneUsersQueryHookResult = ReturnType<typeof useServiceCallApplySceneUsersQuery>;
export type ServiceCallApplySceneUsersLazyQueryHookResult = ReturnType<typeof useServiceCallApplySceneUsersLazyQuery>;
export type ServiceCallApplySceneUsersSuspenseQueryHookResult = ReturnType<typeof useServiceCallApplySceneUsersSuspenseQuery>;
export type ServiceCallApplySceneUsersQueryResult = Apollo.QueryResult<ServiceCallApplySceneUsersQuery, ServiceCallApplySceneUsersQueryVariables>;
export const SubmitServiceCallApplicationDocument = gql`
    mutation SubmitServiceCallApplication($body: SubmitServiceCallApplicationDto!) {
  submitServiceCallApplication(body: $body) {
    id
  }
}
    `;
export type SubmitServiceCallApplicationMutationFn = Apollo.MutationFunction<SubmitServiceCallApplicationMutation, SubmitServiceCallApplicationMutationVariables>;

/**
 * __useSubmitServiceCallApplicationMutation__
 *
 * To run a mutation, you first call `useSubmitServiceCallApplicationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSubmitServiceCallApplicationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [submitServiceCallApplicationMutation, { data, loading, error }] = useSubmitServiceCallApplicationMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSubmitServiceCallApplicationMutation(baseOptions?: Apollo.MutationHookOptions<SubmitServiceCallApplicationMutation, SubmitServiceCallApplicationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SubmitServiceCallApplicationMutation, SubmitServiceCallApplicationMutationVariables>(SubmitServiceCallApplicationDocument, options);
      }
export type SubmitServiceCallApplicationMutationHookResult = ReturnType<typeof useSubmitServiceCallApplicationMutation>;
export type SubmitServiceCallApplicationMutationResult = Apollo.MutationResult<SubmitServiceCallApplicationMutation>;
export type SubmitServiceCallApplicationMutationOptions = Apollo.BaseMutationOptions<SubmitServiceCallApplicationMutation, SubmitServiceCallApplicationMutationVariables>;
export const CompleteReminderDocument = gql`
    mutation CompleteReminder($body: CompleteReminderDto!) {
  completeReminder(body: $body) {
    count
    ids
  }
}
    `;
export type CompleteReminderMutationFn = Apollo.MutationFunction<CompleteReminderMutation, CompleteReminderMutationVariables>;

/**
 * __useCompleteReminderMutation__
 *
 * To run a mutation, you first call `useCompleteReminderMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCompleteReminderMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [completeReminderMutation, { data, loading, error }] = useCompleteReminderMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCompleteReminderMutation(baseOptions?: Apollo.MutationHookOptions<CompleteReminderMutation, CompleteReminderMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CompleteReminderMutation, CompleteReminderMutationVariables>(CompleteReminderDocument, options);
      }
export type CompleteReminderMutationHookResult = ReturnType<typeof useCompleteReminderMutation>;
export type CompleteReminderMutationResult = Apollo.MutationResult<CompleteReminderMutation>;
export type CompleteReminderMutationOptions = Apollo.BaseMutationOptions<CompleteReminderMutation, CompleteReminderMutationVariables>;
export const CreateServiceEventDocument = gql`
    mutation CreateServiceEvent($body: CreateServiceEventDto!) {
  createServiceEvent(body: $body) {
    id
  }
}
    `;
export type CreateServiceEventMutationFn = Apollo.MutationFunction<CreateServiceEventMutation, CreateServiceEventMutationVariables>;

/**
 * __useCreateServiceEventMutation__
 *
 * To run a mutation, you first call `useCreateServiceEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateServiceEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createServiceEventMutation, { data, loading, error }] = useCreateServiceEventMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useCreateServiceEventMutation(baseOptions?: Apollo.MutationHookOptions<CreateServiceEventMutation, CreateServiceEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateServiceEventMutation, CreateServiceEventMutationVariables>(CreateServiceEventDocument, options);
      }
export type CreateServiceEventMutationHookResult = ReturnType<typeof useCreateServiceEventMutation>;
export type CreateServiceEventMutationResult = Apollo.MutationResult<CreateServiceEventMutation>;
export type CreateServiceEventMutationOptions = Apollo.BaseMutationOptions<CreateServiceEventMutation, CreateServiceEventMutationVariables>;
export const UpdateServiceEventDocument = gql`
    mutation UpdateServiceEvent($id: String!, $body: UpdateServiceEventDto!) {
  updateServiceEvent(id: $id, body: $body) {
    id
  }
}
    `;
export type UpdateServiceEventMutationFn = Apollo.MutationFunction<UpdateServiceEventMutation, UpdateServiceEventMutationVariables>;

/**
 * __useUpdateServiceEventMutation__
 *
 * To run a mutation, you first call `useUpdateServiceEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceEventMutation, { data, loading, error }] = useUpdateServiceEventMutation({
 *   variables: {
 *      id: // value for 'id'
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateServiceEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceEventMutation, UpdateServiceEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceEventMutation, UpdateServiceEventMutationVariables>(UpdateServiceEventDocument, options);
      }
export type UpdateServiceEventMutationHookResult = ReturnType<typeof useUpdateServiceEventMutation>;
export type UpdateServiceEventMutationResult = Apollo.MutationResult<UpdateServiceEventMutation>;
export type UpdateServiceEventMutationOptions = Apollo.BaseMutationOptions<UpdateServiceEventMutation, UpdateServiceEventMutationVariables>;
export const EditServiceEventDocument = gql`
    query EditServiceEvent($id: String!) {
  serviceEvent(id: $id) {
    type
    name
    photo
    serviceDate
    mileage
    runningHours
    description
    partnerId
    isTimeLocked
    attachments {
      id
      name
      url
      createdAt
      canDelete
    }
    vehicle {
      hasActiveLicense
    }
  }
}
    `;

/**
 * __useEditServiceEventQuery__
 *
 * To run a query within a React component, call `useEditServiceEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useEditServiceEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEditServiceEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useEditServiceEventQuery(baseOptions: Apollo.QueryHookOptions<EditServiceEventQuery, EditServiceEventQueryVariables> & ({ variables: EditServiceEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EditServiceEventQuery, EditServiceEventQueryVariables>(EditServiceEventDocument, options);
      }
export function useEditServiceEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EditServiceEventQuery, EditServiceEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EditServiceEventQuery, EditServiceEventQueryVariables>(EditServiceEventDocument, options);
        }
export function useEditServiceEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<EditServiceEventQuery, EditServiceEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<EditServiceEventQuery, EditServiceEventQueryVariables>(EditServiceEventDocument, options);
        }
export type EditServiceEventQueryHookResult = ReturnType<typeof useEditServiceEventQuery>;
export type EditServiceEventLazyQueryHookResult = ReturnType<typeof useEditServiceEventLazyQuery>;
export type EditServiceEventSuspenseQueryHookResult = ReturnType<typeof useEditServiceEventSuspenseQuery>;
export type EditServiceEventQueryResult = Apollo.QueryResult<EditServiceEventQuery, EditServiceEventQueryVariables>;
export const ServiceEventDocument = gql`
    query ServiceEvent($id: String!) {
  serviceEvent(id: $id) {
    isTimeLocked
    partnerId
    type
    name
    serviceDate
    mileage
    photo
    runningHours
    description
    attachments {
      id
      name
      url
      createdAt
      canDelete
    }
    vehicle {
      hasActiveLicense
    }
    partner {
      name
    }
  }
}
    `;

/**
 * __useServiceEventQuery__
 *
 * To run a query within a React component, call `useServiceEventQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceEventQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceEventQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useServiceEventQuery(baseOptions: Apollo.QueryHookOptions<ServiceEventQuery, ServiceEventQueryVariables> & ({ variables: ServiceEventQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceEventQuery, ServiceEventQueryVariables>(ServiceEventDocument, options);
      }
export function useServiceEventLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceEventQuery, ServiceEventQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceEventQuery, ServiceEventQueryVariables>(ServiceEventDocument, options);
        }
export function useServiceEventSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ServiceEventQuery, ServiceEventQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ServiceEventQuery, ServiceEventQueryVariables>(ServiceEventDocument, options);
        }
export type ServiceEventQueryHookResult = ReturnType<typeof useServiceEventQuery>;
export type ServiceEventLazyQueryHookResult = ReturnType<typeof useServiceEventLazyQuery>;
export type ServiceEventSuspenseQueryHookResult = ReturnType<typeof useServiceEventSuspenseQuery>;
export type ServiceEventQueryResult = Apollo.QueryResult<ServiceEventQuery, ServiceEventQueryVariables>;
export const DeleteServiceEventAttachmentDocument = gql`
    mutation DeleteServiceEventAttachment($id: String!) {
  deleteServiceEventAttachment(id: $id)
}
    `;
export type DeleteServiceEventAttachmentMutationFn = Apollo.MutationFunction<DeleteServiceEventAttachmentMutation, DeleteServiceEventAttachmentMutationVariables>;

/**
 * __useDeleteServiceEventAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteServiceEventAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceEventAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceEventAttachmentMutation, { data, loading, error }] = useDeleteServiceEventAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteServiceEventAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceEventAttachmentMutation, DeleteServiceEventAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceEventAttachmentMutation, DeleteServiceEventAttachmentMutationVariables>(DeleteServiceEventAttachmentDocument, options);
      }
export type DeleteServiceEventAttachmentMutationHookResult = ReturnType<typeof useDeleteServiceEventAttachmentMutation>;
export type DeleteServiceEventAttachmentMutationResult = Apollo.MutationResult<DeleteServiceEventAttachmentMutation>;
export type DeleteServiceEventAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteServiceEventAttachmentMutation, DeleteServiceEventAttachmentMutationVariables>;
export const UpdatePartnerDocument = gql`
    mutation UpdatePartner($body: UpdatePartnerDTO!) {
  updatePartner(body: $body) {
    id
  }
}
    `;
export type UpdatePartnerMutationFn = Apollo.MutationFunction<UpdatePartnerMutation, UpdatePartnerMutationVariables>;

/**
 * __useUpdatePartnerMutation__
 *
 * To run a mutation, you first call `useUpdatePartnerMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdatePartnerMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updatePartnerMutation, { data, loading, error }] = useUpdatePartnerMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdatePartnerMutation(baseOptions?: Apollo.MutationHookOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdatePartnerMutation, UpdatePartnerMutationVariables>(UpdatePartnerDocument, options);
      }
export type UpdatePartnerMutationHookResult = ReturnType<typeof useUpdatePartnerMutation>;
export type UpdatePartnerMutationResult = Apollo.MutationResult<UpdatePartnerMutation>;
export type UpdatePartnerMutationOptions = Apollo.BaseMutationOptions<UpdatePartnerMutation, UpdatePartnerMutationVariables>;
export const PartnerDocument = gql`
    query Partner {
  partner {
    name
    photo
  }
}
    `;

/**
 * __usePartnerQuery__
 *
 * To run a query within a React component, call `usePartnerQuery` and pass it any options that fit your needs.
 * When your component renders, `usePartnerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePartnerQuery({
 *   variables: {
 *   },
 * });
 */
export function usePartnerQuery(baseOptions?: Apollo.QueryHookOptions<PartnerQuery, PartnerQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PartnerQuery, PartnerQueryVariables>(PartnerDocument, options);
      }
export function usePartnerLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PartnerQuery, PartnerQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PartnerQuery, PartnerQueryVariables>(PartnerDocument, options);
        }
export function usePartnerSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PartnerQuery, PartnerQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PartnerQuery, PartnerQueryVariables>(PartnerDocument, options);
        }
export type PartnerQueryHookResult = ReturnType<typeof usePartnerQuery>;
export type PartnerLazyQueryHookResult = ReturnType<typeof usePartnerLazyQuery>;
export type PartnerSuspenseQueryHookResult = ReturnType<typeof usePartnerSuspenseQuery>;
export type PartnerQueryResult = Apollo.QueryResult<PartnerQuery, PartnerQueryVariables>;
export const ChangeUserInformationDocument = gql`
    mutation ChangeUserInformation($body: ChangeUserInformationDto!) {
  changeUserInformation(body: $body) {
    id
  }
}
    `;
export type ChangeUserInformationMutationFn = Apollo.MutationFunction<ChangeUserInformationMutation, ChangeUserInformationMutationVariables>;

/**
 * __useChangeUserInformationMutation__
 *
 * To run a mutation, you first call `useChangeUserInformationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useChangeUserInformationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [changeUserInformationMutation, { data, loading, error }] = useChangeUserInformationMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useChangeUserInformationMutation(baseOptions?: Apollo.MutationHookOptions<ChangeUserInformationMutation, ChangeUserInformationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ChangeUserInformationMutation, ChangeUserInformationMutationVariables>(ChangeUserInformationDocument, options);
      }
export type ChangeUserInformationMutationHookResult = ReturnType<typeof useChangeUserInformationMutation>;
export type ChangeUserInformationMutationResult = Apollo.MutationResult<ChangeUserInformationMutation>;
export type ChangeUserInformationMutationOptions = Apollo.BaseMutationOptions<ChangeUserInformationMutation, ChangeUserInformationMutationVariables>;
export const UserEditWhoAmIDocument = gql`
    query UserEditWhoAmI {
  whoAmI {
    email
    name
  }
}
    `;

/**
 * __useUserEditWhoAmIQuery__
 *
 * To run a query within a React component, call `useUserEditWhoAmIQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserEditWhoAmIQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEditWhoAmIQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserEditWhoAmIQuery(baseOptions?: Apollo.QueryHookOptions<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>(UserEditWhoAmIDocument, options);
      }
export function useUserEditWhoAmILazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>(UserEditWhoAmIDocument, options);
        }
export function useUserEditWhoAmISuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>(UserEditWhoAmIDocument, options);
        }
export type UserEditWhoAmIQueryHookResult = ReturnType<typeof useUserEditWhoAmIQuery>;
export type UserEditWhoAmILazyQueryHookResult = ReturnType<typeof useUserEditWhoAmILazyQuery>;
export type UserEditWhoAmISuspenseQueryHookResult = ReturnType<typeof useUserEditWhoAmISuspenseQuery>;
export type UserEditWhoAmIQueryResult = Apollo.QueryResult<UserEditWhoAmIQuery, UserEditWhoAmIQueryVariables>;
export const TeamCreateSceneDocument = gql`
    mutation TeamCreateScene($body: InviteUserDto!) {
  invitePartnerUser(body: $body) {
    id
  }
}
    `;
export type TeamCreateSceneMutationFn = Apollo.MutationFunction<TeamCreateSceneMutation, TeamCreateSceneMutationVariables>;

/**
 * __useTeamCreateSceneMutation__
 *
 * To run a mutation, you first call `useTeamCreateSceneMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTeamCreateSceneMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [teamCreateSceneMutation, { data, loading, error }] = useTeamCreateSceneMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useTeamCreateSceneMutation(baseOptions?: Apollo.MutationHookOptions<TeamCreateSceneMutation, TeamCreateSceneMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TeamCreateSceneMutation, TeamCreateSceneMutationVariables>(TeamCreateSceneDocument, options);
      }
export type TeamCreateSceneMutationHookResult = ReturnType<typeof useTeamCreateSceneMutation>;
export type TeamCreateSceneMutationResult = Apollo.MutationResult<TeamCreateSceneMutation>;
export type TeamCreateSceneMutationOptions = Apollo.BaseMutationOptions<TeamCreateSceneMutation, TeamCreateSceneMutationVariables>;
export const TeamIndexSceneDocument = gql`
    query TeamIndexScene {
  users {
    list {
      id
      name
      email
      level
      isPartnerAccountOwner
    }
    totalCount
  }
}
    `;

/**
 * __useTeamIndexSceneQuery__
 *
 * To run a query within a React component, call `useTeamIndexSceneQuery` and pass it any options that fit your needs.
 * When your component renders, `useTeamIndexSceneQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTeamIndexSceneQuery({
 *   variables: {
 *   },
 * });
 */
export function useTeamIndexSceneQuery(baseOptions?: Apollo.QueryHookOptions<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>(TeamIndexSceneDocument, options);
      }
export function useTeamIndexSceneLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>(TeamIndexSceneDocument, options);
        }
export function useTeamIndexSceneSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>(TeamIndexSceneDocument, options);
        }
export type TeamIndexSceneQueryHookResult = ReturnType<typeof useTeamIndexSceneQuery>;
export type TeamIndexSceneLazyQueryHookResult = ReturnType<typeof useTeamIndexSceneLazyQuery>;
export type TeamIndexSceneSuspenseQueryHookResult = ReturnType<typeof useTeamIndexSceneSuspenseQuery>;
export type TeamIndexSceneQueryResult = Apollo.QueryResult<TeamIndexSceneQuery, TeamIndexSceneQueryVariables>;
export const DeleteUserDocument = gql`
    mutation DeleteUser($id: String!) {
  deleteUser(id: $id) {
    id
  }
}
    `;
export type DeleteUserMutationFn = Apollo.MutationFunction<DeleteUserMutation, DeleteUserMutationVariables>;

/**
 * __useDeleteUserMutation__
 *
 * To run a mutation, you first call `useDeleteUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteUserMutation, { data, loading, error }] = useDeleteUserMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteUserMutation(baseOptions?: Apollo.MutationHookOptions<DeleteUserMutation, DeleteUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, options);
      }
export type DeleteUserMutationHookResult = ReturnType<typeof useDeleteUserMutation>;
export type DeleteUserMutationResult = Apollo.MutationResult<DeleteUserMutation>;
export type DeleteUserMutationOptions = Apollo.BaseMutationOptions<DeleteUserMutation, DeleteUserMutationVariables>;
export const UpdateUserLevelDocument = gql`
    mutation UpdateUserLevel($body: UpdateUserLevelDto!) {
  updateUserLevel(body: $body) {
    id
    level
  }
}
    `;
export type UpdateUserLevelMutationFn = Apollo.MutationFunction<UpdateUserLevelMutation, UpdateUserLevelMutationVariables>;

/**
 * __useUpdateUserLevelMutation__
 *
 * To run a mutation, you first call `useUpdateUserLevelMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUserLevelMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUserLevelMutation, { data, loading, error }] = useUpdateUserLevelMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useUpdateUserLevelMutation(baseOptions?: Apollo.MutationHookOptions<UpdateUserLevelMutation, UpdateUserLevelMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateUserLevelMutation, UpdateUserLevelMutationVariables>(UpdateUserLevelDocument, options);
      }
export type UpdateUserLevelMutationHookResult = ReturnType<typeof useUpdateUserLevelMutation>;
export type UpdateUserLevelMutationResult = Apollo.MutationResult<UpdateUserLevelMutation>;
export type UpdateUserLevelMutationOptions = Apollo.BaseMutationOptions<UpdateUserLevelMutation, UpdateUserLevelMutationVariables>;
export const VehicleShowDocument = gql`
    query VehicleShow($id: String!) {
  vehicle(id: $id) {
    id
    token
    name
    type
    registerNumber
    VIN
    mileage
    modelYear
    commissioning
    warranty
    runningHours
    model
    modelYear
    brand
    photo
    description
    photo
    businessId
    hasActiveLicense
    attachments {
      id
      name
      url
      createdAt
      canDelete
    }
    reminders(orderBy: [{date: "asc"}, {title: "asc"}]) {
      id
      title
      date
      isPartnerLocked
    }
    serviceEvents(orderBy: [{serviceDate: "desc"}]) {
      id
      name
      serviceDate
      description
      isPartnerLocked
      mileage
      runningHours
      partner {
        photo
      }
    }
  }
  canSendPartnerServiceCall(vehicleId: $id)
}
    `;

/**
 * __useVehicleShowQuery__
 *
 * To run a query within a React component, call `useVehicleShowQuery` and pass it any options that fit your needs.
 * When your component renders, `useVehicleShowQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useVehicleShowQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useVehicleShowQuery(baseOptions: Apollo.QueryHookOptions<VehicleShowQuery, VehicleShowQueryVariables> & ({ variables: VehicleShowQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<VehicleShowQuery, VehicleShowQueryVariables>(VehicleShowDocument, options);
      }
export function useVehicleShowLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<VehicleShowQuery, VehicleShowQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<VehicleShowQuery, VehicleShowQueryVariables>(VehicleShowDocument, options);
        }
export function useVehicleShowSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<VehicleShowQuery, VehicleShowQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<VehicleShowQuery, VehicleShowQueryVariables>(VehicleShowDocument, options);
        }
export type VehicleShowQueryHookResult = ReturnType<typeof useVehicleShowQuery>;
export type VehicleShowLazyQueryHookResult = ReturnType<typeof useVehicleShowLazyQuery>;
export type VehicleShowSuspenseQueryHookResult = ReturnType<typeof useVehicleShowSuspenseQuery>;
export type VehicleShowQueryResult = Apollo.QueryResult<VehicleShowQuery, VehicleShowQueryVariables>;
export const SendPartnerServiceCallDocument = gql`
    mutation SendPartnerServiceCall($body: SendPartnerServiceCallDto!) {
  sendPartnerServiceCall(body: $body)
}
    `;
export type SendPartnerServiceCallMutationFn = Apollo.MutationFunction<SendPartnerServiceCallMutation, SendPartnerServiceCallMutationVariables>;

/**
 * __useSendPartnerServiceCallMutation__
 *
 * To run a mutation, you first call `useSendPartnerServiceCallMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendPartnerServiceCallMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendPartnerServiceCallMutation, { data, loading, error }] = useSendPartnerServiceCallMutation({
 *   variables: {
 *      body: // value for 'body'
 *   },
 * });
 */
export function useSendPartnerServiceCallMutation(baseOptions?: Apollo.MutationHookOptions<SendPartnerServiceCallMutation, SendPartnerServiceCallMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendPartnerServiceCallMutation, SendPartnerServiceCallMutationVariables>(SendPartnerServiceCallDocument, options);
      }
export type SendPartnerServiceCallMutationHookResult = ReturnType<typeof useSendPartnerServiceCallMutation>;
export type SendPartnerServiceCallMutationResult = Apollo.MutationResult<SendPartnerServiceCallMutation>;
export type SendPartnerServiceCallMutationOptions = Apollo.BaseMutationOptions<SendPartnerServiceCallMutation, SendPartnerServiceCallMutationVariables>;
export const DeleteVehicleAttachmentDocument = gql`
    mutation DeleteVehicleAttachment($id: String!) {
  deleteVehicleAttachment(id: $id)
}
    `;
export type DeleteVehicleAttachmentMutationFn = Apollo.MutationFunction<DeleteVehicleAttachmentMutation, DeleteVehicleAttachmentMutationVariables>;

/**
 * __useDeleteVehicleAttachmentMutation__
 *
 * To run a mutation, you first call `useDeleteVehicleAttachmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteVehicleAttachmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteVehicleAttachmentMutation, { data, loading, error }] = useDeleteVehicleAttachmentMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useDeleteVehicleAttachmentMutation(baseOptions?: Apollo.MutationHookOptions<DeleteVehicleAttachmentMutation, DeleteVehicleAttachmentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteVehicleAttachmentMutation, DeleteVehicleAttachmentMutationVariables>(DeleteVehicleAttachmentDocument, options);
      }
export type DeleteVehicleAttachmentMutationHookResult = ReturnType<typeof useDeleteVehicleAttachmentMutation>;
export type DeleteVehicleAttachmentMutationResult = Apollo.MutationResult<DeleteVehicleAttachmentMutation>;
export type DeleteVehicleAttachmentMutationOptions = Apollo.BaseMutationOptions<DeleteVehicleAttachmentMutation, DeleteVehicleAttachmentMutationVariables>;